{
  "agreements": {
    "defaultTitle": "Соглашение",
    "loading": "Загрузка соглашения…",
    "loadError": "Не удалось загрузить соглашение.",
    "checkbox": "Я ознакомлен(а) и принимаю условия.",
    "confirm": "Принять и продолжить",
    "submitting": "Отправка…"
  },
  "seedance": {
    "videoConsentIntro": "Генерация видео будет использовать ассеты Seedance для: {{names}}. Подтвердите соглашение, чтобы продолжить генерацию.",
    "videoConsentCheckFailed": "Не удалось проверить соглашение Seedance перед генерацией видео.",
    "registrationConsentIntro": "Регистрация ассета загрузит референс героя или образа в библиотеку Seedance. Подтвердите соглашение, чтобы продолжить."
  },
  "canvas": {
    "headTitle": "Холст",
    "title": "Холст",
    "empty": {
      "title": "Создайте первую генерацию",
      "hint": "Выберите модель, добавьте prompt и нажмите «Сгенерировать».",
      "allTitle": "Нет генераций",
      "allHint": "На холстах этого проекта пока нет генераций."
    },
    "feed": {
      "loadingMore": "Загрузка…",
      "end": "Все генерации загружены"
    },
    "panel": {
      "promptPlaceholder": "Опишите, что сгенерировать…",
      "image": "Изображение",
      "video": "Видео",
      "assistant": "Ассистент",
      "errors": "Ошибки",
      "errorsWithCount": "Ошибки · {{count}}",
      "model": "Модель",
      "aspectRatio": "Соотношение сторон",
      "duration": "Длительность",
      "durationSec": "{{count}} сек",
      "attachReference": "Прикрепить референс",
      "referencesTitle": "Референсы",
      "removeReference": "Убрать референс",
      "pickCharacter": "Герои",
      "pickLocation": "Локации",
      "pickProp": "Реквизит",
      "pickPrimitive": "Объекты",
      "pickerEmpty": "Пока нечего выбрать",
      "insertMention": "Вставить упоминание в промпт",
      "previewReference": "Открыть референс в большом размере",
      "dropFilesHint": "Перетащите файлы сюда",
      "dropFilesReject": "Неподдерживаемый тип файла",
      "useProjectStyles": "Использовать проектные стили",
      "useProjectStylesDisabled": "Стили выключены в настройках проекта",
      "useProjectStylesEmpty": "В проекте не заданы стили",
      "viewStyles": "Просмотреть стили",
      "generate": "Сгенерировать",
      "generating": "Генерация…",
      "uploading": "Загрузка…",
      "libraryLoading": "Загрузка библиотеки…",
      "libraryRetry": "Повторить",
      "quality": "Качество",
      "generateAudio": "Генерировать звук",
      "draft": "Черновик",
      "generateAudioEnabledHint": "Генерация звука включена",
      "generationRef": "Ген {{id}}",
      "collapse": "Свернуть панель",
      "expand": "Развернуть панель",
      "libraryDeleted": "Референс удалён из библиотеки",
      "videoConsiderScaleHintLink": "лист размеров"
    },
    "status": {
      "queued": "В очереди",
      "processing": "Обработка",
      "completed": "Готово",
      "failed": "Ошибка"
    },
    "tile": {
      "failed": "Ошибка генерации"
    },
    "errorsList": {
      "empty": "Нет ошибочных генераций"
    },
    "modal": {
      "title": "Генерация",
      "generationId": "ID генерации",
      "board": "Холст",
      "quality": "Оценка",
      "prompt": "Промпт",
      "model": "Модель",
      "aspectRatio": "Соотношение сторон",
      "resolution": "Разрешение",
      "duration": "Длительность",
      "params": "Параметры",
      "references": "Референсы",
      "error": "Ошибка",
      "projectStyles": "Подключены проектные стили",
      "regenerate": "Повторить",
      "openInEditor": "Открыть в редакторе",
      "retryProviderTransient": "Перегенерировать ещё раз",
      "retryProviderTransientShort": "Ещё раз",
      "retryQueued": "Генерация поставлена в очередь.",
      "useAsReference": "Использовать как референс",
      "copyPrompt": "Скопировать промпт",
      "promptCopied": "Промпт скопирован",
      "save": "Сохранить в проект",
      "download": "Скачать оригинал",
      "restoreTrim": "Восстановить оригинал",
      "restoreTrimHint": "Сбросить подрезку и показать полный исходный ролик",
      "trimSaveFailed": "Не удалось сохранить подрезку",
      "copyImage": "Копировать",
      "imageCopied": "Изображение скопировано в буфер обмена",
      "copyFailed": "Не удалось скопировать изображение",
      "close": "Закрыть",
      "previous": "Предыдущая",
      "next": "Следующая",
      "noContent": "Нет контента",
      "savedTo": "Сохранено в проект",
      "savedToOpen": "Открыть {{label}}"
    },
    "save": {
      "title": "Сохранить в проект",
      "target": "Сохранить как",
      "asCharacter": "Нового героя",
      "asLocation": "Новую локацию",
      "asShotStoryboard": "Опорный кадр шота",
      "asShotShootingBoard": "Раскадровку шота",
      "asShotVideo": "Видео шота",
      "name": "Название",
      "namePlaceholder": "Название…",
      "characterNamePlaceholder": "Имя героя",
      "locationNamePlaceholder": "Название локации",
      "selectShot": "Выберите шот",
      "shotNumber": "Шот {{scene}}.{{shot}}",
      "shotLabel": "{{episode}}.{{scene}}.{{shot}}",
      "submit": "Сохранить",
      "saved": "Сохранено в проект",
      "shotCreated": "Шот создан",
      "createShot": "Создать новый шот",
      "pickShot": "Выберите шот",
      "hero": "Герой",
      "location": "Локация",
      "prop": "Реквизит",
      "createCharacter": "Создать нового героя",
      "createLocation": "Создать новую локацию",
      "createProp": "Создать новый реквизит",
      "emptyCharacters": "В проекте пока нет героев.",
      "emptyLocations": "В проекте пока нет локаций.",
      "emptyProps": "В проекте пока нет реквизита.",
      "slotPortrait": "Портрет",
      "slotReference": "Лист референса",
      "slotFrontView": "Вид спереди",
      "slotStepTitle": "Куда сохранить",
      "slotStepHint": "Выберите портрет/вид спереди или лист референса. Превью — эта генерация.",
      "next": "Далее",
      "selectCharacter": "Герой",
      "selectLocation": "Локация",
      "existingCharacter": "Поиск героев…",
      "existingLocation": "Поиск локаций…",
      "propNamePlaceholder": "Название реквизита",
      "videoOnly": "Как видео шота можно сохранить только сгенерированное видео.",
      "noShots": "В проекте пока нет шотов.",
      "pickProject": "Проект",
      "pickProjectHint": "Выберите проект, в который сохранить генерацию.",
      "noProjects": "Нет проектов, в которые можно сохранить. Нужны права на редактирование контента.",
      "loadingCatalogs": "Загрузка каталога проекта…"
    },
    "referencesModal": {
      "title": "Добавить референс",
      "subtitle": "Выберите из проекта или загрузите файлы.",
      "upload": "Загрузить файл",
      "moreTabsAria": "Другие источники референсов",
      "pickFromLibrary": "Выбрать из библиотеки",
      "sketch": "Эскиз",
      "attach": "Прикрепить"
    },
    "sketch": {
      "title": "Эскиз",
      "useAsReference": "Использовать как референс",
      "discardTitle": "Отменить изменения?",
      "discardMessage": "Несохранённые штрихи и правки будут потеряны.",
      "discardConfirm": "Выйти без сохранения",
      "toolSelect": "Выбор",
      "toolPen": "Кисть",
      "toolZoomIn": "Приблизить",
      "toolZoomOut": "Отдалить",
      "toolPan": "Перемещение",
      "toolEraser": "Ластик",
      "toolObjects": "Объекты",
      "shapeRect": "Прямоугольник",
      "shapeEllipse": "Круг",
      "toolArrow": "Стрелка",
      "toolArrowLabel": "Стрелка с подписью",
      "toolText": "Текст",
      "penMarker": "Маркер",
      "penHighlighter": "Хайлайтер",
      "penColor": "Цвет",
      "weight": "Толщина",
      "transparency": "Прозрачность",
      "undo": "Отменить",
      "redo": "Вернуть",
      "delete": "Удалить",
      "layoutFill": "На всю область",
      "layoutLabel": "Размер холста",
      "aiHeading": "Корректировка",
      "resizePanelAria": "Изменить размер панели корректировки",
      "promptPlaceholder": "Опишите правку…",
      "applyAi": "Корректировать",
      "applyingAi": "Корректировка",
      "correctionShort": "Коррекция",
      "quickPrompts": {
        "removeCircled": "Удали обведённый объект",
        "removeBackground": "Удали фон",
        "remakeArrowTarget": "Переделай объект на который указывает стрелка"
      },
      "correctionUnavailable": "Корректировка не настроена",
      "editFailed": "Не удалось отредактировать изображение",
      "fetchImageFailed": "Не удалось загрузить изображение ({{status}})",
      "editCancelled": "Коррекция отменена",
      "confirmFailed": "Не удалось добавить референс",
      "editInSketch": "Редактировать в эскизе",
      "confirmSave": "Сохранить",
      "saveAsViewpoint": "Сохранить как ракурс",
      "confirmSaveLibrary": "Сохранить в библиотеку",
      "savedToLibrary": "Сохранено в библиотеку",
      "textStyle": "Начертание",
      "textSize": "Размер",
      "textFill": "Цвет",
      "defaultFileName": "эскиз-{{number}}",
      "renameTitleHint": "Нажмите, чтобы переименовать файл",
      "startEditing": "Редактировать",
      "viewActionsMenu": "Дополнительные действия",
      "zoomFit": "Весь кадр",
      "zoomPercent": "{{percent}}%",
      "zoomMenuAria": "Масштаб"
    },
    "styles": {
      "title": "Проектные стили",
      "subtitle": "Только для чтения. Редактирование — в настройках проекта.",
      "visualStyle": "Визуальный стиль",
      "genre": "Жанр",
      "tone": "Тон",
      "empty": "Проектные стили не заданы.",
      "disabledHint": "Стили проекта отключены в настройках."
    },
    "errors": {
      "createFailed": "Не удалось запустить генерацию",
      "uploadFailed": "Не удалось загрузить референс",
      "uploadCancelFailed": "Не удалось отменить загрузку",
      "fileTooLarge": "Файл слишком большой (макс. {{max}} МБ)",
      "videoDurationInvalid": "Длительность видео должна быть от {{min}} до {{max}} секунд",
      "videoDurationInvalidNamed": "Не подошли по длительности ({{min}}–{{max}} с): {{names}}",
      "videoDurationUnreadable": "Не удалось определить длительность видео",
      "videoDurationTotalInvalid": "Суммарная длительность видео-референсов не должна превышать {{max}} с (сейчас {{total}} с)",
      "audioDurationInvalid": "Длительность аудио должна быть от {{min}} до {{max}} секунд",
      "audioDurationInvalidNamed": "Не подошли по длительности аудио ({{min}}–{{max}} с): {{names}}",
      "audioDurationUnreadable": "Не удалось определить длительность аудио",
      "audioDurationTotalInvalid": "Суммарная длительность аудио-референсов не должна превышать {{max}} с (сейчас {{total}} с)",
      "audioRefsUnsupported": "Эта видеомодель не поддерживает аудио-референсы",
      "audioRefsLimit": "Можно добавить не больше {{max}} аудио-референсов",
      "saveFailed": "Не удалось сохранить",
      "deleteFailed": "Не удалось удалить",
      "qualitySaveFailed": "Не удалось сохранить оценку",
      "loadFailed": "Не удалось загрузить генерации",
      "noModel": "Выберите модель",
      "noPrompt": "Добавьте промпт",
      "alreadyGenerating": "Дождитесь окончания текущей генерации"
    },
    "sidebar": {
      "renameEdit": "Переименовать холст",
      "deleteBoard": "Удалить холст",
      "deleteConfirm": "Удалить холст «{{title}}»?",
      "deleteConfirmWithUploads": "Удалить холст «{{title}}»?\nБудут удалены загруженные файлы ({{count}}) — они исчезнут и из Библиотеки. Файлы, которые используются где-то ещё, сохранятся.",
      "deleted": "Холст удалён"
    },
    "switcher": {
      "all": "Все",
      "create": "Создать новый",
      "aria": "Выбрать холст",
      "renameTitle": "Переименовать холст",
      "renameName": "Название"
    },
    "actions": {
      "delete": "Удалить",
      "deleteConfirm": "Удалить эту генерацию?",
      "deleted": "Генерация удалена"
    }
  },
  "frameLibrary": {
    "loadFailed": "Не удалось загрузить кадры.",
    "firstFrame": "Первый кадр",
    "lastFrame": "Последний кадр",
    "capturesWithoutVersion": "Скриншоты без версии"
  },
  "library": {
    "headTitle": "Библиотека",
    "title": "Библиотека",
    "loadFailed": "Не удалось загрузить данные.",
    "retry": "Повторить",
    "sections": {
      "shots": "Шоты",
      "canvas": "Холст",
      "flow": "Флоу",
      "sketches": "Эскизы",
      "uploads": "Загрузки",
      "characters": "Герои",
      "locations": "Локации",
      "props": "Реквизит",
      "scenes_3d": "3D Сцены"
    },
    "entity": {
      "empty": "У этой сущности пока нет медиа.",
      "group": {
        "outfit": "Образ",
        "variant": "Вариант",
        "state": "Состояние",
        "viewpoints": "Ракурсы",
        "portrait": "Портреты",
        "expressionSheet": "Мимика",
        "gaitReference": "Походка",
        "actionBeat": "Экшен-биты",
        "voiceDemo": "Голос",
        "referenceVersions": "Версии референса",
        "characterSheetVersions": "Версии листа персонажа",
        "emotionSheetVersions": "Версии листа эмоций",
        "scalePoseVersions": "Версии роста и позы",
        "frontViewVersions": "Версии вида спереди",
        "references": "Референсы",
        "locationPrevizes": "3D-сцены",
        "wallScene": "3D-сцена",
        "scene3dViewpoints": "Ракурсы"
      },
      "item": {
        "reference": "Референс",
        "characterSheet": "Лист персонажа",
        "emotionSheet": "Лист эмоций",
        "scalePose": "Рост и поза",
        "frontView": "Вид спереди",
        "viewpoint": "Ракурс",
        "portrait": "Портрет",
        "expressionSheet": "Мимика",
        "gaitReference": "Походка",
        "actionBeat": "Экшен-бит",
        "voiceDemo": "Голос",
        "referenceInput": "Референс",
        "previz": "Превиз",
        "wallFace": "Стена"
      }
    },
    "view": {
      "grid": "Плитка",
      "list": "Список"
    },
    "group": {
      "latest": "актуальная"
    },
    "search": {
      "placeholder": "Поиск в библиотеке",
      "hint": "Ищет по всему проекту: промпты шотов, названия, имена файлов",
      "clear": "Очистить поиск",
      "tooShort": "Введите хотя бы два символа",
      "searching": "Ищем…",
      "empty": "По запросу «{{query}}» ничего не нашлось",
      "failed": "Не удалось выполнить поиск.",
      "placesGroup": "Папки",
      "assetsGroup": "Ассеты",
      "truncated": "Показаны первые совпадения — уточните запрос",
      "field": {
        "storyboardPrompt": "Промпт кадра",
        "videoPrompt": "Промпт видео",
        "intent": "Суть шота",
        "promptSummary": "Описание промпта",
        "title": "Название",
        "name": "Имя",
        "outfit": "Образ",
        "variant": "Вариант",
        "viewpoint": "Ракурс",
        "state": "Состояние",
        "prompt": "Промпт",
        "filename": "Имя файла"
      }
    },
    "filters": {
      "label": "Фильтр по типу",
      "all": "Все",
      "video": "Видео",
      "image": "Кадры",
      "audio": "Аудио"
    },
    "tree": {
      "season": "Сезон {{number}}",
      "episodeFallback": "Серия {{number}}",
      "animatic": "Аниматик",
      "sceneLabel": "Сцена {{number}}",
      "shotLabel": "Шот {{number}}",
      "transitionShot": "Шот-переход",
      "toggleNode": "Развернуть или свернуть",
      "noShots": "В проекте пока нет шотов.",
      "noCanvases": "На Холсте пока нет досок.",
      "noFlows": "Во Флоу пока нет досок.",
      "no": {
        "characters": "В проекте пока нет героев.",
        "locations": "В проекте пока нет локаций.",
        "props": "В проекте пока нет реквизита.",
        "scenes_3d": "В проекте пока нет 3D-сцен."
      }
    },
    "crumbs": {
      "scene": "Сц. {{number}}",
      "shot": "Шот {{number}}",
      "animatic": "Аниматик"
    },
    "folders": {
      "noScenes": "В эпизоде пока нет сцен.",
      "noShots": "В сцене пока нет шотов.",
      "empty": "Пока нет ассетов."
    },
    "shot": {
      "openShot": "Открыть шот",
      "open": "Открыть",
      "storyboard": "Опорный кадр",
      "shootingBoard": "Раскадровка",
      "video": "Видео",
      "capture": "Скриншот",
      "references": "Референсы",
      "audio": "Звук",
      "audioFallback": "Аудио",
      "animatics": "Аниматики",
      "animaticFallback": "Аниматик",
      "animaticLinked": "прикреплён",
      "animaticDetached": "откреплён",
      "versionFallback": "Версия",
      "versionEmpty": "В версии пока нет кадров.",
      "empty": "В папке шота пока нет ассетов."
    },
    "animatic": {
      "segmentLabel": "Сегмент {{number}}",
      "linkedShot": "шот {{number}}",
      "lockedToShot": "Уже привязан к шоту {{number}}",
      "empty": "В ленте аниматика пока нет сегментов."
    },
    "flow": {
      "empty": "На доске пока нет сгенерированных или загруженных файлов."
    },
    "canvas": {
      "empty": "На доске пока нет готовых генераций.",
      "generationLabel": "Генерация #{{id}}",
      "generationsGroup": "Генерации",
      "uploadsGroup": "Загрузки"
    },
    "sketches": {
      "empty": "Пока нет сохранённых эскизов."
    },
    "uploads": {
      "empty": "Пока ничего не загружено. Перетащите файлы сюда или нажмите «Загрузить».",
      "emptyReadOnly": "В проекте пока нет загруженных файлов.",
      "upload": "Загрузить",
      "hint": "Загрузить файлы в библиотеку проекта: изображения, видео, аудио, до 50 МБ",
      "rename": "Переименовать",
      "renameNameLabel": "Название",
      "delete": "Удалить загрузку",
      "deleteConfirm": "Удалить",
      "deleteFailed": "Не удалось удалить загрузку.",
      "deleteWarning": "Удалить «{{name}}» из библиотеки? Если файл уже назначен кадром или референсом, он там останется."
    },
    "previzes": {
      "empty": "Пока нет превизов. Запишите пролёт камеры в 3D-сцене локации и сохраните его в библиотеку.",
      "noLocation": "Без локации",
      "linkedShot": "привязан к шоту",
      "rename": "Переименовать",
      "renameNameLabel": "Название",
      "delete": "Удалить превиз",
      "deleteConfirm": "Удалить",
      "deleteFailed": "Не удалось удалить превиз.",
      "deleteWarning": "Удалить превиз «{{name}}»?",
      "status": {
        "pending": "В очереди…",
        "processing": "Обработка…",
        "draft": "Черновик",
        "failed": "Ошибка обработки"
      }
    },
    "columns": {
      "name": "Название",
      "type": "Тип",
      "duration": "Хронометраж",
      "date": "Дата",
      "current": "Активная версия"
    },
    "types": {
      "folder": "Папка",
      "image": "Изображение",
      "video": "Видео",
      "audio": "Аудио"
    },
    "viewer": {
      "fps": "{{fps}} к/с",
      "noPreview": "Файл недоступен для просмотра.",
      "prev": "Предыдущий",
      "next": "Следующий"
    },
    "pick": {
      "description": "Выберите ассет и назначьте его кнопкой внизу.",
      "chooseProject": "Выберите проект",
      "noProjects": "Нет доступных проектов",
      "nothingSelected": "Ассет не выбран",
      "selectedCount_one": "Выбран {{count}}",
      "selectedCount_few": "Выбрано {{count}}",
      "selectedCount_many": "Выбрано {{count}}",
      "selectedCount_other": "Выбрано {{count}}",
      "selectedOfLimit": "Выбрано {{count}} из {{limit}}",
      "removeFromSelection": "Убрать «{{label}}» из выбора",
      "toggle": "Выбрать",
      "toggleTree": "Показать или скрыть дерево папок",
      "reason": {
        "needMedia": "Сюда можно {{kinds}}",
        "notReady": "Файл ещё готовится",
        "noSource": "За этим превью нет файла — назначить нельзя",
        "alreadyPicked": "Уже прикреплён",
        "limitReached": "Больше {{count}} за раз выбрать нельзя"
      },
      "media": {
        "image": "изображение",
        "video": "видео",
        "audio": "аудио",
        "animatic": "сегмент аниматика",
        "shot_animatic": "аниматик шота",
        "previz": "превиз",
        "or": " или "
      }
    }
  },
  "analytics": {
    "headTitle": "Аналитика",
    "title": "Аналитика",
    "subtitle": "Производственная сводка и узкие места пайплайна.",
    "kpiEpisodes": "Серии (утв./всего)",
    "kpiScenes": "Сцены (утв./всего)",
    "kpiStoryboard": "Шоты со storyboard",
    "kpiVideo": "Шоты с видео",
    "kpiErrors": "Ошибки генерации",
    "kpiQueued": "В очереди задач",
    "kpiRuntime": "Хронометраж",
    "readinessTitle": "Средняя готовность визуала",
    "bottlenecksTitle": "Узкие места",
    "noBottlenecks": "Нет явных блокировок",
    "pipelineTitle": "Распределение этапов"
  },
  "camerasPage": {
    "headTitle": "Камеры",
    "title": "Библиотека постановок камеры",
    "studioTitle": "Системные пресеты камеры",
    "companyTitle": "Пресеты камеры",
    "selectHint": "Выберите камеру слева, чтобы открыть карточку.",
    "newCameraName": "Новая камера",
    "saveFailed": "Не удалось сохранить камеру",
    "deleteConfirmTitle": "Удалить камеру «{{name}}»?",
    "deleteConfirmMessage": "Действие необратимо.",
    "deleteConfirmAction": "Удалить",
    "destroyBlocked": "Камера используется в шотах.",
    "copied": "Камера скопирована",
    "addCamera": "Добавить камеру",
    "actionsAria": "Действия со списком камер",
    "empty": "Камер пока нет.",
    "sections": {
      "system": "Системные",
      "company": "Компания",
      "project": "Проект"
    },
    "builtinBadge": "Базовый",
    "hiddenBadge": "Скрыт",
    "addFavorite": "В избранное",
    "removeFavorite": "Убрать из избранного",
    "delete": "Удалить",
    "demoTitle": "Демо",
    "demoEmpty": "Демо пока нет",
    "demoFailed": "Не удалось сгенерировать демо камеры",
    "demoReady": "Демо камеры готово",
    "emptyPrompt": "Сначала добавьте фрагмент промпта",
    "demoProvidersOnly": "Для демо камеры нужен настроенный video provider проекта",
    "regenerate": "Перегенерировать",
    "generate": "Сгенерировать",
    "promptLabel": "Фрагмент системного промпта",
    "promptPlaceholder": "Опишите движение камеры…",
    "descriptionLabel": "Описание",
    "narrativeLabel": "Драматургическая цель",
    "whenLabel": "Когда применять",
    "tagsLabel": "Теги",
    "tagsPlaceholder": "теги, через, запятую",
    "listTitle": "Камеры",
    "filterPlaceholder": "Поиск по названию…",
    "clearFilter": "Очистить поиск",
    "filterEmpty": "Ничего не найдено.",
    "hide": "Скрыть",
    "restore": "Отобразить",
    "copyToProject": "Скопировать в проект",
    "copyToCompany": "Скопировать в компанию",
    "pickerTitle": "Выбор камеры",
    "close": "Закрыть",
    "previewPlay": "Смотреть превью",
    "previewPause": "Пауза превью",
    "previewLoading": "Загрузка превью…",
    "searchPlaceholder": "Поиск камер…",
    "noResults": "Камеры не найдены",
    "pickerLoading": "Загрузка камер…",
    "loadFailed": "Не удалось загрузить камеры"
  },
  "versions": {
    "headTitle": "Версии",
    "title": "История версий",
    "subtitle": "Автоматические снимки перед перегенерацией серий и сцен. Восстановление подменяет текущие данные; перед этим создаётся новый снимок «как сейчас», чтобы можно было откатиться снова.",
    "derivedFrom": "Основа: snapshot #{{id}}",
    "restoreButton": "Восстановить из снимка",
    "doubleClickRestore": "Двойной клик — восстановить из снимка (с подтверждением)",
    "restoreHintEpisodes": "Заменит все серии выбранного сезона и вложенные сцены и шоты на состояние из снимка. Текущие данные перед этим архивируются.",
    "restoreHintScenes": "Архивирует текущие активные сцены и шоты серии и восстанавливает дерево из снимка; старые записи и медиа остаются в базе (archived_at).",
    "restoreConfirm": "{{hint}}\n\nПродолжить восстановление снимка «{{label}}»?",
    "notRestorable": "Восстановление из этого типа снимка пока не поддерживается (только «episodes» и «scenes»)."
  },
  "script": {
    "headTitle": "Сценарий",
    "title": "Сценарий",
    "originalStory": "Исходная история",
    "episodeFallback": "Серия {{number}}",
    "editingOriginalStory": "Исходная история проекта",
    "save": "Сохранить",
    "seasonEpisodeLabel": "Сезон {{season}} · E{{episode}}",
    "saveEpisode": "Сохранить эпизод",
    "scopePickerAria": "Исходная история или серия",
    "editorAriaLabel": "Текст сценария",
    "editorPlaceholder": "Пишите историю здесь…",
    "askAgent": "Спросить агента",
    "makeShots": "Сделать шоты",
    "askAgentMessage": "Посмотри этот фрагмент и ответь:\n\n{{excerpt}}",
    "makeShotsMessage": "Разбей этот фрагмент на сцены и шоты:\n\n{{excerpt}}",
    "extractCharactersTitle": "Извлечь героев?",
    "extractCharactersMessage": "Ассистент создаст или обновит персонажей по сценарию.",
    "extractLocationsTitle": "Извлечь локации?",
    "extractLocationsMessage": "Ассистент создаст или обновит локации по сценарию.",
    "extractConfirm": "Извлечь",
    "assistantTab": "Ассистент сценариста",
    "screenplayPlaceholder": "ИНТ. МЕСТО — ВРЕМЯ. Enter — следующий элемент, Tab — сменить тип",
    "scenesTab": "Сцены",
    "versionsTab": "Версии",
    "synopsisHeading": "Синопсис",
    "importSynopsis": "Перенести синопсис в сценарий",
    "scenesHeading": "Сцены · {{count}}",
    "untitledScene": "Без заголовка",
    "sceneMeta": "{{length}} стр · ≈ {{time}} · с. {{pages}}",
    "pagesValue": "{{value}} стр",
    "timingHint": "Справочно: 1 страница ≈ 1 минута",
    "draftsHeading": "Драфты",
    "draftLabelPlaceholder": "Название драфта",
    "saveDraft": "Сохранить",
    "historyHeading": "История правок",
    "revisionEdit": "Правки · {{author}}",
    "revisionEvent": {
      "before_restore": "Перед восстановлением",
      "restored": "Восстановлено из {{source}}"
    },
    "saveFailed": "Не удалось сохранить сценарий",
    "restoreConfirm": "Применить «{{label}}» как текущий текст? Текущий останется в истории правок.",
    "unsaved": "есть несохранённые изменения",
    "savedAt": "сохранено в {{time}}",
    "comparingWith": "сравнение с «{{label}}»",
    "viewSheets": "Листы",
    "viewFlow": "Поток",
    "paperTheme": "Бумага в цвет темы",
    "paperLight": "Светлая бумага",
    "compareInline": "В тексте",
    "compareSide": "Рядом",
    "restoreVersion": "Применить",
    "closeCompare": "Закрыть",
    "elementAria": "Элемент сценария",
    "elements": {
      "scene": "Сцена",
      "action": "Действие",
      "character": "Персонаж",
      "parenthetical": "Ремарка",
      "dialogue": "Реплика",
      "transition": "Переход"
    },
    "more": "(ДАЛЕЕ)",
    "contd": "(ПРОД.)",
    "pageLabel": "стр. {{page}}",
    "seasonFallback": "Сезон {{number}}",
    "seasonSummary": "Серий: {{episodes}} · сценарии у {{written}} · {{pages}} стр · ≈ {{time}} из {{target}}",
    "editStory": "Редактировать",
    "storyEmpty": "Исходная история пока не написана.",
    "writeScript": "Написать сценарий",
    "addSynopsis": "Добавить синопсис",
    "syncScenes": "Обновить сцены серии",
    "syncScenesHint": "Создать и обновить сцены серии по заголовкам ИНТ./НАТ.: название, текст, длительность, локация и герои. Сцены без заголовка не удаляются.",
    "syncScenesDone": "Сцены по сценарию: новых {{created}}, обновлено {{updated}}, без заголовка {{unmatched}}",
    "backToList": "К списку сценариев"
  },
  "video": {
    "missingFrameConfirm": {
      "title": "Опорный кадр ещё не готов",
      "message": "У некоторых шотов ещё нет опорного кадра. Без него модель будет опираться только на промпт и референсные материалы. Продолжить генерацию видео без опорного кадра?",
      "confirm": "Сгенерировать видео без кадра"
    }
  },
  "header": {
    "viewOnly": "Только просмотр",
    "sharedAccess": "Общий доступ",
    "settingsAccess": "Доступ к настройкам",
    "changeFrameFormat": "Сменить формат"
  },
  "promptOverrides": {
    "loadFailed": "Не удалось загрузить данные промптов.",
    "saveFailed": "Ошибка сохранения.",
    "resetFailed": "Ошибка сброса.",
    "networkError": "Сетевая ошибка.",
    "loading": "Загрузка промптов…",
    "templatesTitle": "Шаблоны",
    "templatesHint": "Зелёная полоска — есть переопределение для этого проекта.",
    "overridden": "переопределён",
    "projectOverride": "Переопределение для этого проекта",
    "globalValue": "Глобальное значение (без переопределения)",
    "globalValueHeading": "Глобальное значение",
    "copyAsBase": "Скопировать как основу",
    "empty": "(пусто)",
    "projectOverrideLabel": "Переопределение для проекта",
    "projectOverrideHint": "Оставьте пустым, чтобы использовать глобальное значение.",
    "overridePlaceholder": "Оставьте пустым, чтобы использовать глобальный промпт",
    "saveOverride": "Сохранить переопределение",
    "resetToGlobal": "Сбросить к глобальному",
    "selectTemplate": "Выберите шаблон из списка слева."
  },
  "providers": {
    "intro": "Модели генерации для этого проекта. По умолчанию наследуются из",
    "studioAi": "Studio → Platform Config",
    "text": "Текст",
    "storyboardImages": "Картинки сториборда",
    "defaultFromStudio": "По умолчанию (из Studio)",
    "defaultFromStudioShort": "По умолчанию из Studio",
    "studioDefaultNow": "Сейчас: {{model}}",
    "frameCorrection": "Корректировка кадра",
    "locations": "Локации",
    "characters": "Герои",
    "characterOutfits": "Образы героев",
    "cover": "Обложка",
    "video": "Видео",
    "resolution": "Разрешение видео",
    "generateSyncedAudio": "Генерировать синхронизированное аудио",
    "seedanceDraftDefault": "Seedance: черновик при 480p по умолчанию",
    "generateSyncedAudioHint": "Выключено — ролик без звуковой дорожки. Аниматик, голоса и аудио-референсы всё равно учитываются для липсинка и ритма.",
    "klingVariantFidelity": "Kling: image_fidelity вариантов локации",
    "klingOutfitFidelity": "Kling: image_fidelity образов героя",
    "animaticPromptBlock": "Блок промпта при референсе аниматика (@Video1)",
    "animaticPromptPlaceholder": "Пусто — текст из Studio → Системные промпты (seedance_animatic_reference_video)",
    "animaticPromptHint": "Дописывается к пользовательскому промпту видео, когда для шота включена отправка сегмента аниматика как референсное видео. Переопределяет глобальный шаблон только для этого проекта.",
    "videoCorrection": "Корректировка видео",
    "voiceTts": "Озвучка (TTS)",
    "voiceCreation": "Создание голоса",
    "audioTranscription": "Транскрипция аудио"
  },
  "overview": {
    "headTitle": "{{name}} — обзор",
    "title": "Обзор проекта",
    "storyAndFormat": "История и формат",
    "editStoryAndFormat": "Редактировать историю и формат",
    "projectType": "Тип",
    "genre": "Жанр",
    "narrativeTone": "Нарративный тон",
    "tone": "Тон",
    "medium": "Медиум",
    "visualStyle": "Стиль картинок",
    "stylesDisabled": "Без стилей",
    "format": "Формат",
    "deprecatedValue": "Текущее значение устарело: «{{value}}». Выберите актуальный вариант из каталога.",
    "workingEpisode": "Серия в работе",
    "workingEpisodeHint": "Общий указатель для команды. Личный выбор на сториборде и в других разделах сохраняется отдельно.",
    "countsLine": "Сезонов: {{seasons}} · Серий: {{episodes}} · Сцен: {{scenes}} · Шотов: {{shots}}",
    "readinessLine": "Средняя готовность визуала (storyboard + видео по шотам): {{value}}",
    "approveStory": "Утвердить историю",
    "approveStoryDisabled": "История уже утверждена. Измените текст в разделе «Сценарий» или «Настройки», затем снова нажмите здесь.",
    "originalStory": "Исходный текст истории",
    "showFull": "Показать полностью",
    "loading": "Загрузка…",
    "excerptHint": "В обзор загружен только начальный фрагмент текста — полный объём подгружается по запросу.",
    "loadFailed": "Не удалось загрузить текст",
    "noStory": "Текст ещё не задан. Откройте раздел «Сценарий» или создайте проект с описанием истории.",
    "cast": "Актеры",
    "castSection": "Герои",
    "castHint": "Персонажи проекта; миниатюра — референс, если он уже сгенерирован.",
    "noPhoto": "Нет фото",
    "noCharacters": "Персонажей пока нет. Добавьте их вручную или извлеките из истории в разделе",
    "charactersLink": "«Герои»",
    "openCharacters": "Открыть раздел «Герои»",
    "extractCharacters": "Извлечь персонажей из истории",
    "locations": "Локации",
    "locationsHint": "Локации проекта; миниатюра — референс, если он уже сгенерирован.",
    "noLocations": "Локаций пока нет. Добавьте их вручную или извлеките из истории в разделе",
    "locationsLink": "«Локации»",
    "openLocations": "Открыть раздел «Локации»",
    "extractLocations": "Извлечь локации из истории",
    "props": "Реквизит",
    "propsHint": "Реквизит проекта; миниатюра — референс, если он уже сгенерирован.",
    "noProps": "Реквизита пока нет. Добавьте его вручную или извлеките из истории в разделе",
    "propsLink": "«Реквизит»",
    "openProps": "Открыть раздел «Реквизит»",
    "extractProps": "Извлечь реквизит из истории",
    "extractPropsConfirmTitle": "Извлечь реквизит из истории?",
    "extractPropsConfirmMessage": "LLM проанализирует исходный текст и добавит или обновит реквизит проекта. Уже созданные вручную предметы сохранятся.",
    "extractPropsConfirmAction": "Извлечь",
    "extractPropsBusy": "Извлечение…",
    "cover": "Обложка проекта",
    "model": "Модель",
    "noCover": "Обложки пока нет.",
    "noCoverHint": "Утвердите историю — обложка создастся автоматически, либо нажмите кнопку ниже.",
    "regenerateCover": "Перегенерировать обложку",
    "uploadCover": "Загрузить обложку",
    "watchAssembly": "Смотреть монтаж",
    "team": "Команда",
    "author": "Автор",
    "teamOpen": "Открыть команду",
    "teamUnnamed": "Без имени",
    "sharedWith": "по шаре",
    "readiness": "Готовность",
    "readinessHint": "Серии, сцены, сториборд и видео по шотам (утверждено / всего).",
    "statsRecalculating": "Идёт генерация структуры — цифры обновятся после завершения",
    "kpiEpisodes": "Серии готовы",
    "kpiScenes": "Сцены подтверждены",
    "kpiStoryboard": "Storyboard",
    "kpiVideo": "Видео клипы",
    "kpiRuntime": "Хронометраж",
    "assemblyBuilds": "Сборки серий (монтаж)",
    "assemblyHint": "Готовые MP4 и недавние задачи склейки. Полный монтаж — в разделе «Монтаж серии».",
    "readyFiles": "Готовые файлы",
    "assemblyLink": "Монтаж",
    "openInPlayer": "Открыть в плеере",
    "download": "Скачать",
    "mergeJobs": "Задачи склейки (последние)",
    "episodeNotSpecified": "Серия не указана",
    "defaultFromStudio": "По умолчанию из Studio",
    "recentGenerations": "Последние генерации",
    "recentGenerationsHint": "Канвас и шоты",
    "recentGenerationsEmpty": "Пока нет завершённых генераций в проекте.",
    "canvasModalLoadFailed": "Не удалось загрузить генерацию холста",
    "flowNodeMissing": "Нода флоу уже удалена",
    "unknownAuthor": "Без автора",
    "kindImage": "Изображение",
    "kindVideo": "Видео",
    "subjectCanvas": "Холст #{{id}}",
    "subjectFlow": "{{title}}",
    "subjectFlowMissing": "Флоу",
    "openShot": "Открыть шот",
    "lastEditedShot": "Последний редактируемый шот",
    "noShotsYet": "Шотов пока нет — создайте первый, чтобы начать работу над сторибордом.",
    "createFirstShot": "Создать первый шот",
    "createFirstShotHint": "Сезон, серия и сцена будут созданы автоматически, если их ещё нет.",
    "shotNoDescription": "Без описания",
    "jobs": "Задачи",
    "versions": "Версии",
    "teamEmpty": "Участники команды появятся здесь после приглашения."
  },
  "studioAssembly": {
    "assembly": "Сборка",
    "studio": "Студия",
    "storyboardSource": "Storyboard",
    "openInStudio": "Открыть в студии",
    "storyboardSourceHint": "Текущее состояние сториборда",
    "customAssemblies": "Сборки",
    "storyboardReadonly": "Порядок шотов как на раскадровке. Чтобы переставить их, создайте сборку.",
    "storyboardEmptyScene": "В сцене нет шотов."
  },
  "assembly": {
    "headTitle": "Монтаж серии",
    "title": "Монтаж серии",
    "episode": "Серия",
    "noEpisodes": "Нет серий — сгенерируйте эпизоды.",
    "tabTimeline": "Таймлайн",
    "tabHistory": "История",
    "tabHistoryCount": "История ({{count}})",
    "assembled": "Собрано:",
    "assembledSeconds": "{{seconds}} с",
    "target": "цель ~{{seconds}} с",
    "mutedCount_one": "({{count}} выключено)",
    "mutedCount_other": "({{count}} выключено)",
    "underTarget": "Хронометраж ниже цели — добавьте клипы или удлините шоты.",
    "missingClips": "Есть шоты без видео.",
    "saveOrder": "Сохранить порядок",
    "mergeEpisode": "Склеить серию",
    "mergeEpisodeTitle": "Поставить задачу склейки в очередь",
    "actionsAria": "Действия монтажа",
    "previewBuild": "Просмотр сборки",
    "overlap": "Оверлэп:",
    "overlapNone": "Без оверлэпа",
    "overlapTransitions": "Для переходов",
    "overlapAll": "Для всех кадров",
    "shotNumbers": "Номера шотов",
    "statsTitle": "Хронометраж",
    "settingsTitle": "Настройки склейки",
    "sceneLabel": "Сцена {{number}}",
    "shotsCount_one": "{{count}} шот",
    "shotsCount_few": "{{count}} шота",
    "shotsCount_many": "{{count}} шотов",
    "shotsCount_other": "{{count}} шота",
    "sceneDuration": "{{seconds}} с",
    "emptyScene": "В сцене нет шотов — перетащите сюда.",
    "dragScene": "Перетащить сцену",
    "dragShot": "Перетащить шот",
    "saving": "Сохранение…",
    "saved": "Сохранено",
    "saveFailed": "Не удалось сохранить",
    "timeline": "Таймлайн",
    "timelineHint": "Порядок берётся из структуры серии: сцены по номеру, шоты внутри по порядку. Изменения сохраняются автоматически.",
    "noShots": "Нет шотов в этой серии — сначала сгенерируйте структуру и шоты.",
    "clipAria": "Клип {{label}}, {{seconds}} с{{muted}}",
    "clipMutedSuffix": ", выключен",
    "muteInAssembly": "Выключить из монтажа",
    "unmuteInAssembly": "Включить в монтаж",
    "noClip": "Нет клипа",
    "stitchScene": "Склеить",
    "selectionLabel": "Выбранные шоты ({{count}})",
    "clipPreview": {
      "title": "Шот {{label}}",
      "titleWithScene": "Шот {{label}} — {{scene}}",
      "open": "Открыть просмотр шота {{label}}",
      "noMedia": "Нет видео или изображения для этого шота",
      "prev": "Предыдущий шот",
      "next": "Следующий шот"
    },
    "selection": {
      "count": "Выбрано: {{count}}",
      "selectAll": "Выделить все",
      "clear": "Снять выделение",
      "mute": "Выключить",
      "unmute": "Включить",
      "stitch": "Склеить"
    },
    "noHistory": "Нет истории монтажей для этой серии.",
    "clipsCount_one": "{{count}} клип",
    "clipsCount_other": "{{count}} клипов",
    "fileUnavailable": "Файл не сохранён — склейка сделана до перехода на облачное хранилище",
    "preview": "Просмотр",
    "exportNoEpisode": "Серия не выбрана",
    "exportNoEpisodeMsg": "Выберите серию в списке выше.",
    "exportEmptyTimeline": "Пустой таймлайн",
    "exportEmptyTimelineMsg": "На таймлайне нет активных клипов.",
    "exportDataError": "Ошибка данных",
    "exportDataErrorMsg": "Не удалось определить id шотов. Обновите страницу.",
    "exportNoVideo": "Нет видео для склейки",
    "exportNoVideoMsg": "Ни у одного активного шота нет сгенерированного ролика.",
    "shotFallback": "Шот #{{id}}",
    "overlapLabels": {
      "none": "Без оверлэпа",
      "transitions_only": "Оверлэп для переходов",
      "all": "Оверлэп для всех кадров"
    },
    "result": {
      "ready": "Готовая сборка",
      "readyFresh": "Склейка готова",
      "newBadge": "новое",
      "hint": "MP4 готов — можно посмотреть и скачать",
      "watch": "Смотреть",
      "download": "Скачать",
      "dismiss": "Скрыть",
      "dismissHint": "Скрыть — сборка останется в «Просмотре сборки» и в «Склейках»"
    },
    "previewDialog": {
      "title": "Просмотр сборки",
      "hint": "Воспроизведение готового MP4. Ниже кнопка скачивания файла.",
      "downloadFile": "Скачать файл",
      "paramsTitle": "Параметры",
      "resolution": "Разрешение",
      "aspectRatio": "Соотношение сторон",
      "shotsStitched": "Склеено шотов",
      "duration": "Длительность",
      "overlap": "Режим оверлэпа",
      "muted": "Заглушено",
      "fileSize": "Размер файла"
    },
    "exportDialog": {
      "gotIt": "Понятно",
      "confirmMerge": "Подтверждение склейки",
      "episode": "Серия",
      "scope": "Область",
      "clips": "Клипов",
      "muted": "Выключено",
      "skippedVideosTitle_one": "{{count}} шот без видео",
      "skippedVideosTitle_few": "{{count}} шота без видео",
      "skippedVideosTitle_many": "{{count}} шотов без видео",
      "skippedVideosTitle_other": "{{count}} шота без видео",
      "missingVideoTitle": "При отсутствии видео",
      "substituteAnimatic": "Подставлять аниматик",
      "substituteShotImage": "Подставлять изображение шота",
      "showShotLabelsOnVideo": "Указывать номера шотов на видео",
      "overlapTitle": "Оверлэп",
      "merge": "Склеить"
    },
    "mutedCount_few": "({{count}} выключено)",
    "mutedCount_many": "({{count}} выключено)",
    "clipsCount_few": "{{count}} клипа",
    "clipsCount_many": "{{count}} клипов",
    "empty": {
      "title": "Сборок пока нет",
      "description": "Создайте сборку, чтобы расставить сцены и шоты независимо от раскадровки. Первая сборка копирует текущий порядок из раскадровки.",
      "create": "Создать сборку"
    },
    "sidebar": {
      "versions": "Версии",
      "history": "История",
      "splices": "Склейки",
      "versionsCount": "Версии ({{count}})",
      "splicesCount": "Склейки ({{count}})",
      "togglePanel": "Версии и склейки",
      "create": "Создать сборку",
      "actionsMenu": "Действия со сборкой",
      "renameEdit": "Переименовать",
      "renameSave": "Сохранить название",
      "renameCancel": "Отмена",
      "duplicate": "Дублировать",
      "deleteAssembly": "Удалить",
      "deleteConfirm": "Удалить сборку «{{title}}»? Это действие нельзя отменить.",
      "deleted": "Сборка удалена",
      "duplicated": "Сборка продублирована",
      "openPanel": "Открыть панель",
      "closePanel": "Свернуть панель"
    }
  },
  "seasons": {
    "headTitle": "Сезоны и серии",
    "title": "Сезоны и серии",
    "reviewHint": "Бейджи «на ревью» означают, что материал ждёт вашего решения. Чтобы открыть следующий этап пайплайна, утвердите готовые сущности (по очереди или всем проектом сразу):",
    "approveSeasonsTitle": "Помечает все сезоны проекта как утверждённые",
    "approveSeasons": "Утвердить сезоны",
    "approveEpisodesTitle": "Помечает все серии проекта как утверждённые",
    "approveEpisodes": "Утвердить серии",
    "approveScenesTitle": "Помечает все сцены проекта как утверждённые",
    "approveScenes": "Утвердить сцены",
    "approveShotsTitle": "Помечает все шоты проекта как утверждённые",
    "approveShots": "Утвердить шоты",
    "generateAllEpisodes": "Сгенерировать все серии",
    "generateAllScenes": "Сгенерировать сцены (все серии)",
    "generateAllShots": "Сгенерировать шоты (все сцены)",
    "regenerateAllShots": "Перегенерировать все шоты",
    "addSeason": "Добавить сезон",
    "openInStudio": "Открыть в Студии",
    "episodeFallback": "Серия {{number}}",
    "shotFallback": "Шот",
    "actionsAria": "Действия сезонов",
    "seasonTitle": "Сезон {{number}}: {{title}}",
    "addEpisode": "Добавить серию",
    "editSeason": "Редактировать сезон",
    "deleteSeason": "Удалить сезон",
    "deleteSeasonBlocked": "Нельзя удалить сезон с шотами",
    "addFirstEpisode": "Добавить первую серию",
    "editEpisode": "Редактировать серию",
    "deleteEpisode": "Удалить серию",
    "deleteEpisodeBlocked": "Нельзя удалить серию с шотами",
    "addScene": "Добавить сцену",
    "addFirstScene": "Добавить первую сцену",
    "sceneTitle": "Сцена {{number}}: {{title}}",
    "editScene": "Редактировать сцену",
    "archiveScene": "Архивировать сцену",
    "addShot": "Добавить шот",
    "generationDetails": "Детали генерации",
    "location": "Локация",
    "shotsCount_one": "{{count}} шот",
    "shotsCount_other": "{{count}} шотов",
    "shotTitle": "Шот {{number}}",
    "allShotData": "Все данные кадра",
    "llmDetails": "Детали LLM",
    "framePromptFull": "Промпт для кадра — полный текст",
    "llmFieldsHint": "По полям LLM (description / camera / …)",
    "regenerateSceneShots": "Перегенерировать шоты сцены",
    "regenerateSceneShotsTitle": "Перегенерировать шоты этой сцены",
    "dragScene": "Перетащить сцену",
    "dragShot": "Перетащить шот",
    "loadError": "Ошибка загрузки",
    "readFull": "Показать полностью",
    "closeSynopsis": "Закрыть синопсис",
    "editSeasonDialog": "Редактирование сезона",
    "editEpisodeDialog": "Редактирование серии",
    "editSceneDialog": "Редактирование сцены",
    "confirmGenerateEpisodes": "Запустить генерацию всех серий?",
    "confirmGenerateEpisodesMsg": "Будут сгенерированы серии для всех сезонов проекта. Продолжить?",
    "confirmGenerateEpisodesAction": "Сгенерировать",
    "confirmGenerateScenes": "Запустить генерацию сцен?",
    "confirmGenerateScenesMsg": "Будут сгенерированы сцены для всех серий проекта. Продолжить?",
    "confirmGenerateScenesAction": "Сгенерировать",
    "confirmGenerateShots": "Запустить генерацию шотов?",
    "confirmGenerateShotsMsg": "Будут сгенерированы шоты для всех сцен проекта. Продолжить?",
    "confirmGenerateShotsAction": "Сгенерировать",
    "confirmRegenerateShots": "Перегенерировать все шоты?",
    "confirmRegenerateShotsMsg": "Будут перегенерированы все шоты во всех сценах проекта. Продолжить?",
    "confirmRegenerateShotsAction": "Перегенерировать",
    "confirmEpisodesExist": "Серии уже существуют",
    "confirmEpisodesExistMsg": "Повторный запуск создаст новые серии для сезонов. Продолжить?",
    "confirmEpisodesExistAction": "Сгенерировать заново",
    "confirmScenesExist": "Сцены уже существуют",
    "confirmScenesExistMsg": "Повторный запуск перезапишет сцены по сериям и отправит прошлую версию в архив. Продолжить?",
    "confirmScenesExistAction": "Перегенерировать сцены",
    "confirmShotsPartial": "Шоты уже существуют частично",
    "confirmShotsPartialMsg": "Повторный запуск догенерирует только недостающие шоты и не тронет уже созданные. Продолжить?",
    "confirmShotsPartialAction": "Догенерировать",
    "confirmShotsExist": "Шоты уже существуют",
    "confirmShotsExistMsg": "Повторный запуск перегенерирует все шоты во всех сценах, сохранив ручные промпты и storyboard preview. Продолжить?",
    "confirmShotsExistAction": "Перегенерировать все шоты",
    "confirmSceneShotsExist": "Шоты этой сцены уже существуют",
    "confirmSceneShotsExistMsg": "Повторный запуск перегенерирует шоты только для этой сцены. Продолжить?",
    "confirmSceneShotsExistAction": "Перегенерировать шоты сцены",
    "deleteSeasonTitle": "Удалить сезон?",
    "deleteSeasonMsg": "Сезон «{{title}}» и все его серии, сцены и шоты будут удалены безвозвратно.",
    "deleteEpisodeTitle": "Удалить серию?",
    "deleteEpisodeMsg": "Серия «{{title}}» и все её сцены и шоты будут удалены безвозвратно.",
    "archiveSceneTitle": "Архивировать сцену?",
    "archiveSceneMsg": "Сцена «{{title}}» будет архивирована.",
    "delete": "Удалить",
    "archive": "Архивировать",
    "dialogs": {
      "seasonName": "Название",
      "seasonDescription": "Описание",
      "episodeName": "Название",
      "episodeDescription": "Описание",
      "episodeDuration": "Длительность (сек)",
      "sceneName": "Название",
      "scenePurpose": "Назначение сцены",
      "sceneDuration": "Длительность (сек)",
      "sceneDurationPlaceholder": "Или введите вручную…",
      "sceneLocation": "Локация",
      "locationNotSet": "— Не задана —",
      "shotLlmTitle": "Разбор кадра (LLM) — {{label}}",
      "shotLlmEmpty": "Данные генерации отсутствуют.",
      "shotLlmDescription": "Описание",
      "shotLlmVisualDetails": "Визуальные детали",
      "shotLlmShotType": "Тип плана",
      "shotLlmCamera": "Камера",
      "shotLlmVisual": "Визуал",
      "shotLlmAction": "Действие",
      "shotLlmDialogue": "Диалог",
      "shotLlmSound": "Звук",
      "shotLlmEmotion": "Эмоция",
      "sceneLlmTitle": "Детали генерации — {{title}}",
      "sceneLlmEmpty": "Данные генерации отсутствуют.",
      "sceneLlmCharacters": "Участники в кадре",
      "sceneLlmMood": "Настроение",
      "sceneLlmLocationText": "Локация в тексте",
      "sceneLlmVisualAnchors": "Визуальные опоры",
      "sceneLlmDialogue": "Реплики",
      "sceneLlmCharacterFallback": "Персонаж",
      "sceneLlmSound": "Звук",
      "sceneLlmAtmosphere": "Атмосфера:",
      "sceneLlmMusic": "Музыка:"
    },
    "shotsCount_few": "{{count}} шота",
    "shotsCount_many": "{{count}} шотов"
  },
  "storyboard": {
    "headTitle": "Storyboard",
    "title": "Storyboard",
    "untitled": "Без названия",
    "format": "Формат:",
    "target": "Цель:",
    "addScene": "Добавить сцену",
    "createSeries": "Создать серию",
    "noSeriesHint": "В проекте пока нет серий. Создайте первую, чтобы начать работу над сторибордом.",
    "episode": "Серия",
    "noEpisodes": "Нет серий",
    "jobs": "Задачи",
    "versions": "Версии",
    "timelineHint": "Таймлайн серии: каждая сцена — отдельная строка с блоком «Сцена» и её кадрами {{format}} с переносом по ширине. Клик по превью открывает шот. Клик по подписи под кадром выбирает шот: справа откроется ассистент этого шота, сам шот не откроется. Shift+клик по подписи добавляет шот в выборку или убирает из неё, Esc снимает выборку.",
    "timelineHintTitle": "Справка по таймлайну",
    "timelineHintAria": "Справка по таймлайну",
    "sceneShotsFromScriptPrompt": "Разложи сцену {{number}} «{{title}}» на шоты по сценарию",
    "sceneShotsFromScriptPromptUntitled": "Разложи сцену {{number}} на шоты по сценарию",
    "hiddenShot": "Скрытый шот {{label}} — нажмите для просмотра",
    "insertShotBefore": "Вставить шот перед",
    "insertShotAfter": "Вставить шот после",
    "selectEpisode": "Выберите серию",
    "animaticSegment": "Сегмент аниматика",
    "segment": "Сегмент:",
    "start": "Начало:",
    "end": "Конец:",
    "duration": "Длительность:",
    "episodeLabel": "Серия:",
    "segmentFrames": "Кадры сегмента",
    "firstFrame": "Первый кадр",
    "poster": "Постер",
    "lastFrame": "Последний кадр",
    "noSegmentData": "Нет данных сегмента.",
    "actionsAria": "Действия storyboard",
    "createFrames": "Создать кадры ({{count}})",
    "createAllFrames": "Создать все кадры",
    "createVideo": "Создать видео ({{count}})",
    "createAllVideo": "Создать все видео",
    "missingStoryboardHint": "У некоторых выбранных шотов нет кадра — сначала сгенерируйте кадры",
    "noAnimaticSegment": "У шота нет сегмента аниматика.",
    "segmentLoadFailed": "Не удалось загрузить данные сегмента.",
    "saveFailed": "Ошибка сохранения",
    "tile": {
      "previewShot": "Просмотр шота {{label}}",
      "selectShotNoFrame": "Выбрать шот {{label}} для генерации (нет кадра)",
      "noFrameGenerate": "Нет кадра — сгенерируйте",
      "generatingVideo": "Видео…",
      "generatingFrame": "Кадр…",
      "charactersAria": "Герои кадра: {{count}}, настроить привязку",
      "noPeopleMode": "Режим «без людей»: к промпту добавлен запрет на фигуры; референсы героев не используются. Настроить.",
      "charactersTitle": "Герои сцены и кадра — привязать или отвязать",
      "locationAria": "Локация кадра: {{location}}",
      "locationNotSet": "не задана",
      "locationTitle": "Локация: {{name}}",
      "linkLocation": "Привязать локацию",
      "propsAria": "Реквизит кадра: {{count}}, настроить привязку",
      "propsTitle": "Реквизит кадра — привязать или отвязать",
      "animaticSegment": "Сегмент аниматика",
      "linkedAnimatic": "Связан с аниматиком",
      "uploadFrame": "Загрузить кадр",
      "uploadFrameTitle": "Загрузить кадр с компьютера",
      "storyboardVersions": "Версии сториборда",
      "shootingBoard": "Раскадровка",
      "videoVersions": "Версии видео",
      "selectShotAria": "Выбрать шот {{label}} для генерации",
      "deselectShotAria": "Снять выделение с шота {{label}}",
      "shotFallback": "Шот",
      "editShot": "Редактировать шот",
      "editDescription": "Изменить описание",
      "editDescriptionShot": "Изменить описание шота",
      "generatingStatus": "Генерируется",
      "correctingStatus": "Корректировка",
      "errorStatus": "Ошибка",
      "errorDetailsTitle": "Ошибка генерации — {{label}}",
      "newStatus": "Новый",
      "statusLabel": "Статус",
      "reviewCommentPlaceholder": "Комментарий к правкам…",
      "shotFormatDiffers": "Формат шота: {{shotFormat}} (у проекта {{projectFormat}})",
      "heroesUpdated": "Обновились после последней генерации: {{names}}"
    },
    "createShot": {
      "transitionTitle": "Шот-переход {{label}}",
      "newShotTitle": "Новый шот {{label}}",
      "sceneHint": "Сцена {{sceneNumber}}: {{title}}. Шот будет вставлен после позиции {{position}}.",
      "makeTransition": "Сделать шот-переход",
      "transitionBetween": "Будет создан специальный шот-переход между шотом {{left}} и шотом {{right}}.",
      "transitionEpisodeStart": "Будет создан зацикливающий переход перед началом серии: последний кадр шота {{last}} → первый кадр шота {{first}}.",
      "transitionEpisodeEnd": "Будет создан зацикливающий переход после конца серии: последний кадр шота {{last}} → первый кадр шота {{first}}.",
      "transitionFrames": "Будут использованы последний кадр шота {{left}} и первый кадр шота {{right}} для интерполяции.",
      "transitionEpisodeFrames": "Будут использованы последний кадр шота {{last}} и первый кадр шота {{first}} для зацикливания.",
      "lastFrameAlt": "Последний кадр шота {{number}}",
      "lastFrameLabel": "Шот {{label}} — последний кадр",
      "firstFrameAlt": "Первый кадр шота {{number}}",
      "firstFrameLabel": "Шот {{label}} — первый кадр",
      "transitionDescription": "Описание перехода",
      "shotDescription": "Описание шота",
      "transitionPlaceholder": "Как происходит переход: плавное слияние, вспышка, наезд камеры…",
      "shotPlaceholder": "Кратко: что происходит в кадре…",
      "autoFillHint": "Если оставить пустым — заполнится автоматически",
      "duration": "Длительность",
      "characters": "Герои",
      "location": "Локация",
      "noLocation": "Без локации",
      "useNeighborLastFrame": "Использовать последний кадр видео соседнего шота",
      "neighborLastFrameHint": "Последний кадр видео шота {{number}} будет назначен как сториборд нового шота",
      "creating": "Создание…",
      "createTransition": "Создать переход",
      "createShot": "Создать шот",
      "untitledScene": "без названия",
      "numberUnavailable": "Нет свободного номера между соседними шотами.",
      "cannotCreateTitle": "Нет возможности создать шот",
      "cannotCreateHint": "Между этими шотами нет свободного номера. Чтобы вставить шот сюда, сначала удалите следующий."
    }
  },
  "entityProfile": {
    "mentionHint": "Введите @ для характеристик",
    "generationModel": "Модель генерации",
    "projectSettings": "Настройки проекта",
    "save": "Сохранить",
    "saving": "Сохранение…",
    "savedState": "Сохранено",
    "saveErrorRetry": "Ошибка, повторить",
    "sections": {
      "height": "Рост",
      "role": "Роль",
      "short_description": "Краткое описание",
      "personality": "Характер",
      "appearance_summary": "Внешность",
      "visual_prompt_summary": "Визуальные детали",
      "gait": "Походка",
      "voice": "Голос",
      "description": "Описание",
      "mood": "Настроение/атмосфера",
      "visual_traits": "Визуальные черты",
      "diagonal_size": "Размер по диагонали",
      "category": "Категория",
      "visual_description": "Визуальное описание",
      "purpose": "Назначение",
      "materials": "Материалы",
      "features": "Особенности",
      "consistency_notes": "Заметки по консистентности"
    }
  },
  "assetMedia": {
    "clearVersion": "Удалить",
    "clearVersionConfirm": "Удалить текущую версию?\nТекущая версия останется в истории."
  },
  "charactersPage": {
    "headTitle": "Герои",
    "title": "Герои",
    "listTitle_one": "Герои · {{count}}",
    "listTitle_few": "Герои · {{count}}",
    "listTitle_many": "Герои · {{count}}",
    "listTitle_other": "Герои · {{count}}",
    "add": "Добавить героя",
    "createCharacterSheet": "Создать лист героя",
    "recreateCharacterSheet": "Пересоздать",
    "createCharacterSheetAssetsMissing": "Сначала добавьте хотя бы один портрет, headless-референс или обычный референс",
    "floatingActionsMenuAria": "Дополнительные действия со списком героев",
    "extractUpdate": "Извлечь / обновить",
    "assignToShots": "LLM определяет, кто из героев участвует в каждой сцене, и проставляет их по кадрам. Выполняется в фоне; пустой ответ модели не стирает уже привязанный каст.",
    "assignToShotsBtn": "Расставить по кадрам",
    "assignToShotsConfirmTitle": "Расставить героев по кадрам?",
    "assignToShotsConfirmMessage": "LLM определит участие в сценах и проставит каст в фоне. Пустой ответ модели не сбросит уже привязанный каст.",
    "assignToShotsConfirmAction": "Расставить",
    "actionsAria": "Действия со списком героев",
    "empty": {
      "title": "Пока нет героев",
      "description": "Добавьте героя вручную или извлеките персонажей из сценария"
    },
    "emptyList": "Пока нет героев. Нажмите «Извлечь / обновить» или «Добавить героя».",
    "selectLeft": "Выберите героя слева, чтобы открыть карточку.",
    "selectFromStrip": "Выберите героя выше, чтобы открыть карточку.",
    "createOrExtract": "Создайте или извлеките героев.",
    "queued": "Герой в очереди…",
    "generate": "Сгенерировать героя",
    "prompt": "Промпт",
    "versions": "Версии",
    "uploadVersion": "Загрузить файл",
    "regenerate": "Перегенерировать",
    "correct": "Корректировать",
    "noReference": "Нет референса для корректировки",
    "edit": "Редактировать",
    "replacePortrait": "Заменить портрет",
    "replaceReferenceSheet": "Заменить лист референса",
    "replaceEmotionSheet": "Заменить лист эмоций",
    "replaceOutfitImage": "Заменить образ",
    "editNameHint": "Нажмите, чтобы переименовать",
    "delete": "Удалить",
    "episodeVariants": "Варианты по сериям",
    "reference": "Референс:",
    "model": "модель",
    "configureStudio": "Настроить в Studio",
    "referenceAlt": "Референс: {{name}}",
    "fieldShortDescription": "Краткое описание",
    "fieldAppearance": "Внешность",
    "fieldVisualSummary": "Визуальное резюме",
    "noDescriptions": "Описания пока нет. Откройте «Редактировать», чтобы заполнить.",
    "profileHeading": "Профиль",
    "profilePlaceholder": "Опишите героя. Вставляйте характеристики через @…",
    "outfits": "Образы (одежда)",
    "addOutfit": "Добавить образ",
    "noOutfits": "Пока нет образов. По умолчанию герой показывается в «базовом» референсе.",
    "outfitQueuedHint": "Генерация уже в очереди — отслеживайте прогресс на панели «Задачи»",
    "outfitNeedBaseHint": "Сначала сгенерируйте или загрузите базовый референс героя — он будет использован как основа для образа",
    "queuedShort": "В очереди…",
    "noRef": "Ещё не сгенерировано",
    "seedanceRegister": "Зарегистрировать ассет",
    "seedanceRegisterAll": "Зарегистрировать всё",
    "seedanceRegisterAllTitle": "Зарегистрировать все незарегистрированные референсы персонажей и образов в Seedance",
    "seedanceRegisterAllDoneTitle": "Все доступные референсы уже зарегистрированы в Seedance",
    "seedanceNeedReference": "Сначала сгенерируйте или загрузите референс",
    "seedanceRegistered": "В Seedance",
    "seedanceRegisteredButton": "Зарегистрирован",
    "seedanceFailedHint": "Ошибка регистрации в Seedance — нажмите, чтобы повторить",
    "seedanceProcessing": "Регистрация…",
    "seedanceRegistrationStarted": "Началась регистрация",
    "seedanceFailed": "Ошибка Seedance",
    "seedanceRegisterTitle": "Зарегистрировать образ персонажа в библиотеке ассетов Seedance",
    "destroyBlocked": "Герой используется в сценах или шотах.",
    "deleteCharacterConfirmTitle": "Удалить героя «{{name}}»?",
    "deleteCharacterConfirmMessage": "Карточка героя и связанные версии референсов будут удалены. Действие необратимо.",
    "deleteCharacterConfirmAction": "Удалить",
    "deleteOutfitConfirmTitle": "Удалить образ «{{name}}»?",
    "deleteOutfitConfirmMessage": "Связи с шотами сбросятся на базовый референс героя. Действие необратимо.",
    "deleteOutfitConfirmAction": "Удалить",
    "newCharacter": "Новый герой",
    "editCharacter": "Редактирование «{{name}}»",
    "referenceTitle": "Референс: {{name}}",
    "outfitTitle": "{{name}} · образ «{{outfit}}»",
    "outfitAlt": "Образ {{name}}",
    "outfitEnlargeAria": "Увеличить изображение образа «{{name}}»",
    "newOutfit": "Новый образ",
    "editOutfit": "Редактирование образа «{{name}}»",
    "generating": "Генерация…",
    "portraitTitle": "Портрет",
    "portraitEmpty": "Портрет ещё не сгенерирован",
    "portraitViewEmpty": "{{view}} ещё не сгенерирован",
    "portraitViews": {
      "front": "Анфас",
      "three_quarter_left": "3/4 слева",
      "three_quarter_right": "3/4 справа",
      "profile_left": "Профиль слева",
      "profile_right": "Профиль справа",
      "back": "Затылок"
    },
    "generatePortrait": "Сгенерировать портрет",
    "generatePortraitView": "Сгенерировать {{view}}",
    "regeneratePortraitView": "Перегенерировать этот ракурс",
    "generateReferenceSheet": "Сгенерировать",
    "generateExpressionSheet": "Сгенерировать",
    "generateGaitReference": "Сгенерировать",
    "generateActionBeat": "Сгенерировать",
    "portraitRequired": "Сначала сгенерируйте портрет",
    "visualReferenceOptional": "Необязательные визуальные референсы для генерации",
    "portraitVersionsTitle": "Версии портрета",
    "portraitCorrectTitle": "Корректировка портрета",
    "layoutTitle": "Раскладка",
    "referenceSheetTitle": "Лист референса",
    "referenceSheetVersionsTitle": "Версии листа референса",
    "outfitVersionsTitle": "Версии образа",
    "characterSheetTitle": "Лист героя",
    "characterSheetNeedsUpdate": "Референсы изменились, лист героя нужно обновить",
    "characterSheetEmpty": "Лист героя ещё не создан",
    "characterSheetVersionsTitle": "Версии листа героя",
    "scaleSheetBtn": "Масштаб",
    "scaleSheetTitle": "Масштаб героев",
    "scaleSheetHint": "Настройте рост героев и превью относительных размеров. Изменения применяются ко всем героям проекта.",
    "scaleSheetHeightLabel": "Рост",
    "scaleSheetDirtyCount": "Изменено персонажей: {{count}}",
    "scaleSheetApplyAll": "Применить все",
    "scaleSheetNeedTwo": "Добавьте хотя бы одного героя.",
    "scaleSheetPreviewTitle": "Лист размеров",
    "scaleSheetLoadError": "Не удалось загрузить лист размеров",
    "scaleSheetSaveError": "Не удалось сохранить рост",
    "regenerateScalePose": "Перегенерировать A-pose",
    "scalePoseCharacterSheetRequired": "Сначала сгенерируйте лист героя или лист референса",
    "close": "Закрыть",
    "emotionSheetTitle": "Лист эмоций",
    "emotionSheetEmpty": "Лист эмоций ещё не создан",
    "generateEmotionSheet": "Сгенерировать",
    "regenerateEmotionSheet": "Перегенерация",
    "emotionSheetVersionsTitle": "Версии листа эмоций",
    "emotionSheetPortraitRequired": "Сначала добавьте хотя бы один портрет или ракурс",
    "emotionSheetCorrectTitle": "Корректировка листа эмоций",
    "emotionSheetNoVersionHint": "Сначала сгенерируйте лист эмоций",
    "referenceSheetEmpty": "Лист референса ещё не сгенерирован",
    "referenceSheetEmptyHeadless": "Референс без головы ещё не сгенерирован",
    "referenceSheetScopeFullBody": "Полный рост",
    "referenceSheetScopeHeadless": "Без головы",
    "referenceTitleHeadless": "Референс без головы: {{name}}",
    "expressionSheetTitle": "Демо эмоций",
    "expressionSheetVersionsTitle": "Версии демо эмоций",
    "gaitReferenceTitle": "Демо походки",
    "gaitReferenceVersionsTitle": "Версии демо походки",
    "actionBeatTitle": "Демо экшена",
    "actionBeatVersionsTitle": "Версии демо экшена",
    "voiceDemoTitle": "Голосовое демо",
    "voiceDemoVersionsTitle": "Версии голосовых демо",
    "voiceDemoEmpty": "Голосовое демо ещё не сгенерировано",
    "expressionSheetEmpty": "Демо эмоций ещё не сгенерировано",
    "gaitReferenceEmpty": "Демо походки ещё не сгенерировано",
    "actionBeatEmpty": "Демо экшена ещё не сгенерировано",
    "generateVoiceDemo": "Сгенерировать",
    "voiceCorrectTitle": "Корректировка голосового демо",
    "mediaEmpty": "Ещё не сгенерировано",
    "expressionCorrectTitle": "Корректировка демо эмоций",
    "gaitCorrectTitle": "Корректировка демо походки",
    "actionCorrectTitle": "Корректировка демо экшена",
    "mediaDeleteConfirm": "Удалить эту версию медиа?",
    "mediaGalleryHint": "Активируйте нужную версию. Сгенерированные версии появятся после завершения задач.",
    "mediaGalleryUpload": "Загрузить",
    "mediaGalleryLoading": "Загрузка версий…",
    "mediaGalleryEmpty": "Пока нет версий. Сгенерируйте с карточки героя.",
    "mediaGalleryNoPreview": "Нет превью",
    "mediaGalleryActive": "Активная",
    "mediaGalleryUploaded": "Загружено",
    "mediaGalleryGenerated": "Сгенерировано",
    "mediaGalleryCleared": "Очищено",
    "mediaGalleryMakeActive": "Сделать активной",
    "mediaCorrectionHint": "Опишите, что изменить. Новая версия будет сгенерирована на основе выбранного медиа.",
    "mediaCorrectionPlaceholder": "например: смягчить улыбку, изменить цвет волос, ярче освещение…",
    "videoCorrectionPublicUrlHint": "Для коррекции видео нужен публичный URL. Загруженные файлы на localhost могут не сработать — используйте туннель, если задача падает.",
    "sections": {
      "look": "Внешность",
      "emotions": "Эмоции",
      "outfits": "Образы",
      "sheet": "Лист героя",
      "voice": "Голос",
      "overview": "Обзор"
    },
    "overview": {
      "title": "Все герои",
      "stripLabel": "Все",
      "portraits": "Портреты {{done}}/{{total}}",
      "outfits_one": "{{count}} образ",
      "outfits_few": "{{count}} образа",
      "outfits_many": "{{count}} образов",
      "outfits_other": "{{count}} образа",
      "notCreated": "Ещё не создано",
      "views_one": "{{count}} ракурс",
      "views_few": "{{count}} ракурса",
      "views_many": "{{count}} ракурсов",
      "views_other": "{{count}} ракурса",
      "stale": "устарел",
      "openVoice": "Открыть голос",
      "zoom": "Увеличить: {{name}}",
      "viewsLabel": "Ракурсы",
      "onlyFront": "Только анфас — добавьте ракурсы"
    },
    "referenceViews": {
      "front": "Спереди",
      "three_quarter_front": "3/4 спереди",
      "profile_left": "Профиль слева",
      "profile_right": "Профиль справа",
      "three_quarter_back": "3/4 сзади",
      "back": "Сзади"
    },
    "emotions": {
      "neutral": "Нейтрально",
      "joy": "Радость",
      "anger": "Гнев",
      "sadness": "Грусть",
      "surprise": "Удивление",
      "fear": "Страх",
      "disgust": "Отвращение",
      "contempt": "Презрение",
      "embarrassment": "Смущение",
      "fatigue": "Усталость",
      "determination": "Решимость",
      "laughter": "Смех",
      "scream": "Крик",
      "thoughtful": "Задумчивость"
    },
    "settings": {
      "viewCount": "Ракурсов",
      "portraitViewsHint": "Генерируются только выбранные ракурсы. Анфас обязателен, остальные строятся от него.",
      "referenceViewsHint": "Меньше ракурсов — крупнее фигура: референс для видео ужимается до 800 px. Для экшена и сложного костюма — 4 или 6.",
      "emotionSet_one": "Набор эмоций · {{count}}",
      "emotionSet_few": "Набор эмоций · {{count}}",
      "emotionSet_many": "Набор эмоций · {{count}}",
      "emotionSet_other": "Набор эмоций · {{count}}",
      "emotionsMax": "Не больше {{count}} эмоций на листе",
      "presetBase": "Базовый",
      "presetDrama": "Драма",
      "presetOwn": "Свой",
      "customEmotion": "Своя эмоция",
      "customEmotionPlaceholder": "Своя эмоция, например «сдерживает смех»",
      "addEmotion": "Добавить эмоцию",
      "framing": "Кадр",
      "framingFace": "Лицо",
      "framingWaist": "По пояс",
      "angle": "Ракурс",
      "angleThreeQuarter": "3/4",
      "captions": "Подписи на листе",
      "yes": "Да",
      "no": "Нет",
      "captionsHint": "Без подписей лист можно сразу отдавать в видео: модель не перенесёт текст в кадр. Названия эмоций всё равно уходят в промпт.",
      "sheetFormat": "Формат листа",
      "sheetParts": "Что на листе",
      "parts": {
        "portraits": "Портреты",
        "full_body": "Раскладка",
        "headless": "Без головы",
        "emotions": "Эмоции",
        "name": "Имя героя"
      },
      "formats": {
        "3x2": {
          "title": "3:2 · Классический",
          "hint": "Сетка портретов, тело без головы и эмоции, с подписями"
        },
        "16x9": {
          "title": "16:9 · Видео-реф",
          "hint": "Крупный анфас, рост и эмоции — для горизонтальных шотов"
        },
        "9x16": {
          "title": "9:16 · Вертикальный",
          "hint": "Для вертикальных проектов, фигура выше"
        },
        "1x1": {
          "title": "1:1 · Компактный",
          "hint": "Лицо и полный рост, без лишнего"
        }
      },
      "videoReference": "В генерацию видео уходит",
      "videoReferenceHint": "Если выбран лист героя, а его ещё нет, уйдёт раскладка.",
      "portraitViews": "Ракурсы портрета",
      "base": "основа",
      "emotionSetTitle": "Набор",
      "removeEmotion": "Убрать «{{name}}»",
      "closeAdd": "Закрыть",
      "framingSize": "Крупность",
      "readySets": "Готовые",
      "sheetReused": "Нашли готовый лист в этом формате — включили его, пересобирать не нужно",
      "sheetReady": "готов"
    },
    "versionsFeed": {
      "title": "Прошлые версии",
      "titleOf": "Прошлые версии · {{name}}",
      "empty": "Других версий пока нет",
      "makeCurrent": "Сделать актуальной",
      "zoom": "Увеличить версию от {{caption}}"
    },
    "outfitCatalog": {
      "new": "Новый",
      "all": "Все",
      "onCharacter": "На герое",
      "garmentHint": "Одежда · на невидимом манекене",
      "description": "Описание",
      "noDescription": "Без описания",
      "inShot": "В шоте",
      "inShotGarment": "Уходит вместе с листом героя «{{name}}»: модель одевает героя в эти вещи.",
      "inShotOnCharacter": "Уходит вместо базового листа героя — с лицом, причёской и гримом."
    },
    "cast": {
      "filters": {
        "all": "Все",
        "ready": "Готовы",
        "stale": "Устарели",
        "missing": "Не готовы",
        "busy": "В работе"
      },
      "status": {
        "ready": "Готов к видео",
        "sheetStale": "Лист устарел",
        "generating": "Генерируется",
        "noPortrait": "Не готов: нет портрета",
        "noLayout": "Не готов: нет раскладки"
      },
      "assetState": {
        "busy": "в работе",
        "missing": "нет",
        "stale": "пересобрать",
        "create": "Создать"
      },
      "assets": {
        "portrait": "портрет",
        "layout": "раскладка",
        "emotions": "лист эмоций",
        "sheet": "лист героя",
        "outfits": "образы"
      },
      "inVideo": "в видео",
      "portraits": "Портреты {{done}}/{{total}}",
      "finishMissing": "Доделать недостающее · {{count}}",
      "finishMessage": "Доделай недостающие ассеты героев по порядку: {{list}}. Сначала портреты, потом раскладки, эмоции и листы.",
      "emptyFilter": "Нет героев с таким статусом",
      "finishConfirmTitle": "Доделать недостающее?",
      "finishConfirmIntro_one": "Агент героев сгенерирует {{count}} ассет по порядку:",
      "finishConfirmIntro_few": "Агент героев сгенерирует {{count}} ассета по порядку:",
      "finishConfirmIntro_many": "Агент героев сгенерирует {{count}} ассетов по порядку:",
      "finishConfirmIntro_other": "Агент героев сгенерирует {{count}} ассета по порядку:",
      "finishConfirmHint": "Генерации списываются с баланса проекта. Ход работы — в общем чате героев.",
      "finishConfirmAction": "Запустить"
    },
    "voiceSummary": {
      "none": "Голос ещё не выбран",
      "pick": "Подобрать голос",
      "noPreview": "Превью нет",
      "open": "Открыть голос",
      "more_one": "Ещё {{count}} голос",
      "more_few": "Ещё {{count}} голоса",
      "more_many": "Ещё {{count}} голосов",
      "more_other": "Ещё {{count}} голоса",
      "status": {
        "draft": "черновик",
        "failed": "ошибка"
      }
    }
  },
  "propsPage": {
    "headTitle": "Реквизит",
    "title": "Реквизит",
    "add": "Добавить предмет",
    "seedanceRegister": "Зарегистрировать ассет",
    "seedanceNeedReference": "Сначала сгенерируйте или загрузите референс",
    "seedanceRegistered": "В Seedance",
    "seedanceRegisteredButton": "Зарегистрирован",
    "seedanceFailedHint": "Ошибка регистрации в Seedance — нажмите, чтобы повторить",
    "seedanceProcessing": "Регистрация…",
    "seedanceRegisterTitle": "Зарегистрировать референс реквизита в библиотеке ассетов Seedance",
    "extractUpdate": "Извлечь / обновить",
    "extractConfirmTitle": "Извлечь / обновить реквизит?",
    "extractConfirmMessage": "LLM проанализирует исходный текст и добавит или обновит реквизит проекта. Уже созданные вручную предметы сохранятся.",
    "extractConfirmAction": "Извлечь / обновить",
    "empty": {
      "title": "Пока нет реквизита",
      "description": "Добавьте предмет вручную или извлеките реквизит из сценария"
    },
    "selectFromStrip": "Выберите реквизит сверху, чтобы открыть карточку.",
    "createOrExtract": "Создайте или извлеките реквизит.",
    "actionsAria": "Действия со списком реквизита",
    "floatingActionsMenuAria": "Другие действия с реквизитом",
    "editNameHint": "Нажмите, чтобы переименовать",
    "generate": "Сгенерировать",
    "generateFrontView": "Сгенерировать",
    "regenerateFrontView": "Перегенерировать вид спереди",
    "regenerate": "Перегенерировать",
    "uploadVersion": "Загрузить файл",
    "referenceEmpty": "Лист референса ещё не сгенерирован",
    "layoutTitle": "Раскладка",
    "frontViewTitle": "Вид спереди",
    "frontViewEmpty": "Вид спереди ещё не сгенерирован",
    "frontViewVersionsTitle": "Версии вида спереди",
    "referenceSheetVersionsTitle": "Версии листа референса",
    "stateVersionsTitle": "Версии состояния",
    "prompt": "Промпт",
    "correct": "Корректировать",
    "replaceFrontView": "Заменить вид спереди",
    "replaceReferenceSheet": "Заменить лист референса",
    "replaceStateImage": "Заменить изображение состояния",
    "noReference": "Нет референса для корректировки",
    "edit": "Редактировать",
    "delete": "Удалить",
    "episodeVariants": "Варианты по сериям",
    "referenceTitle": "Лист референса",
    "profilePlaceholder": "Опишите предмет. Вставляйте характеристики через @…",
    "states": "Состояния",
    "addState": "Добавить состояние",
    "noStates": "Пока нет состояний. По умолчанию реквизит показывается в «базовом» референсе.",
    "stateQueuedHint": "Генерация уже в очереди — отслеживайте прогресс на панели «Задачи»",
    "stateNeedBaseHint": "Сначала сгенерируйте или загрузите базовый референс реквизита — он будет использован как основа для состояния",
    "stateTitle": "{{name}} · состояние «{{state}}»",
    "stateAlt": "Состояние {{name}}",
    "stateEnlargeAria": "Увеличить изображение состояния «{{name}}»",
    "queuedShort": "В очереди…",
    "noRef": "Ещё не сгенерировано",
    "destroyBlocked": "Реквизит используется в шотах.",
    "deleteProp": "Удалить реквизит «{{name}}»?",
    "deleteState": "Удалить состояние «{{name}}»? Связанные шоты переключатся на «базовый» референс.",
    "newProp": "Новый реквизит",
    "editProp": "Редактирование «{{name}}»",
    "newState": "Новое состояние",
    "editState": "Редактирование состояния «{{name}}»",
    "generating": "генерация",
    "usageCount_one": "{{count}} шот",
    "usageCount_few": "{{count}} шота",
    "usageCount_many": "{{count}} шотов",
    "usageCount_other": "{{count}} шота",
    "scaleSheetBtn": "Масштаб",
    "scaleSheetTitle": "Масштаб предметов",
    "scaleSheetHint": "Настройте размер предметов по диагонали и превью относительных размеров. Изменения применяются ко всем предметам проекта.",
    "scaleSheetHeightLabel": "Размер по диагонали",
    "scaleSheetDirtyCount": "Изменено предметов: {{count}}",
    "scaleSheetApplyAll": "Применить все",
    "scaleSheetNeedTwo": "Для листа размеров нужен минимум 1 предмет.",
    "scaleSheetPreviewTitle": "Лист размеров предметов",
    "scaleSheetLoadError": "Не удалось загрузить лист размеров предметов",
    "scaleSheetSaveError": "Не удалось сохранить размер по диагонали",
    "close": "Закрыть"
  },
  "locationsPage": {
    "headTitle": "Локации",
    "title": "Локации",
    "listTitle_one": "Локации · {{count}}",
    "listTitle_few": "Локации · {{count}}",
    "listTitle_many": "Локации · {{count}}",
    "listTitle_other": "Локации · {{count}}",
    "add": "Добавить локацию",
    "seedanceRegister": "Зарегистрировать ассет",
    "seedanceNeedReference": "Сначала сгенерируйте или загрузите референс",
    "seedanceRegistered": "В Seedance",
    "seedanceRegisteredButton": "Зарегистрирован",
    "seedanceFailedHint": "Ошибка регистрации в Seedance — нажмите, чтобы повторить",
    "seedanceProcessing": "Регистрация…",
    "seedanceRegisterTitle": "Зарегистрировать референс локации в библиотеке ассетов Seedance",
    "extractUpdate": "Извлечь / обновить",
    "extractHint": "Подтягивает локации из сценария через ассистента: совпадения по имени обновляются, новые добавляются. Уже созданные локации не удаляются.",
    "assignToShots": "LLM подбирает локацию для каждой сцены и проставляет её в кадры без локации. Уже заданные локации кадров не меняются. Выполняется в фоне.",
    "assignToShotsBtn": "Расставить локации по кадрам",
    "assignToShotsConfirmTitle": "Расставить локации по кадрам?",
    "assignToShotsConfirmMessage": "LLM подбирает локацию для каждой сцены и проставляет её в кадры без локации. Уже заданные локации кадров не меняются. Выполняется в фоне.",
    "assignToShotsConfirmAction": "Расставить",
    "emptyList": "Пока нет локаций. Нажмите «Извлечь / обновить» или «Добавить».",
    "empty": {
      "title": "Пока нет локаций",
      "description": "Добавьте локацию вручную или извлеките их из сценария"
    },
    "selectLeft": "Выберите локацию слева, чтобы открыть карточку.",
    "selectFromStrip": "Выберите локацию сверху, чтобы открыть карточку.",
    "createOrExtract": "Создайте или извлеките локации.",
    "actionsAria": "Действия со списком локаций",
    "floatingActionsMenuAria": "Другие действия с локациями",
    "queued": "В очереди…",
    "generate": "Сгенерировать локацию",
    "prompt": "Промпт",
    "versions": "Версии ракурса",
    "correct": "Корректировать",
    "replaceView": "Заменить {{view}}",
    "roomViewer": {
      "open": "3D-вид",
      "title": "{{name}} · 3D-комната",
      "titleWithVariant": "{{name}} · {{variant}} · 3D-комната",
      "description": "Стороны света локации. Пустые ракурсы можно сгенерировать.",
      "close": "Закрыть",
      "wallsTitle": "Ракурсы (16:9)",
      "createViewpoint": "Создать ракурс",
      "createViewpointNeedImages": "Сначала сгенерируйте хотя бы одно изображение во вью",
      "creatingViewpoint": "Сохранение…",
      "viewpointsTitle": "Ракурсы",
      "viewpointsEmpty": "Пока нет дополнительных ракурсов — сделайте снимок из 3D-вида.",
      "applyViewpoint": "К камере",
      "renameViewpointTitle": "Переименовать ракурс",
      "renameViewpointNameLabel": "Название",
      "cameraTitle": "Камера",
      "hud": "x {{x}}  y {{y}}  z {{z}}   {{yaw}}°   fov {{fov}}°",
      "shape": "Форма",
      "shapeCube": "Куб",
      "shapeCylinder": "Цилиндр",
      "shapeSphere": "Сфера",
      "generatePanorama": "Сгенерировать панораму",
      "regeneratePanorama": "Перегенерировать панораму",
      "height": "Высота",
      "minimapHint": "клик по карте = переместиться",
      "controlsHint": "ЛКМ — осмотр\nW A S D / стрелки — ход\nShift — обзор как у куба\nR / F — высота\nколесо — зум",
      "controlsHintSphere": "ЛКМ — осмотр\nколесо — зум\n(в режиме сферы ходьба отключена)",
      "preset": {
        "center": "Центр",
        "nw": "СЗ угол",
        "ne": "СВ угол",
        "sw": "ЮЗ угол",
        "se": "ЮВ угол"
      }
    },
    "scene3d": {
      "open": "Открыть 3D-сцену",
      "previzesSectionTitle": "3D Сцены",
      "addScene": "Добавить 3D сцену",
      "previzesEmpty": "Для этой локации пока нет 3D-сцен.",
      "previzesLoading": "Загрузка…",
      "previzesLoadMore": "Показать ещё",
      "previzEmpty": "Видео ещё нет",
      "tileEmpty": "Обложки пока нет",
      "title": "{{name}} · 3D-сцена",
      "description": "Расставляйте примитивы, героев и реквизит.",
      "close": "Закрыть",
      "backToLocations": "Назад к локациям",
      "backToScenes3d": "Вернуться в 3D-Сцены",
      "flyQrLabel": "Открыть полёт на мобильном",
      "viewQrLabel": "Вид из камеры на мобильном",
      "characters": "Персонажи",
      "props": "Пропы",
      "heroes": "Добавить объекты",
      "add": "Добавить",
      "pickerTitle": "Добавить на сцену",
      "pickerSubtitle": "Герои, реквизит и объекты проекта.",
      "missing": "удалён",
      "defaultSize": "размер по умолчанию",
      "reset": "Очистить сцену",
      "resetConfirm": "Очистить содержимое 3D-сцены?\nДействие необратимо.",
      "removeObject": "Удалить объект",
      "objectColor": "Цвет объекта",
      "objectColorClear": "Сбросить цвет объекта",
      "heroFigure": "Форма героя",
      "objectPath": "Траектория объекта",
      "figures": {
        "humanoid": "Человек",
        "quadruped": "Животное на четырёх лапах",
        "biped": "Животное на двух лапах"
      },
      "record": "Запись (Shift+Пробел)",
      "stopRecord": "Остановить запись (Shift+Пробел)",
      "recordCancel": "Отменить запись (Shift+Пробел)",
      "recordArmedHint": "Начните движение - запись начнётся",
      "trajectory": {
        "mode": "Траектория камеры (T)",
        "draw": "Рисовать",
        "drawHint": "Рисовать траекторию (вкл/выкл)",
        "goToPathStart": "Старт",
        "goToPathStartHint": "Перейти к началу траектории",
        "lookAlong": "Вдоль",
        "lookObserve": "Наблюдение",
        "lookRecorded": "Взгляд",
        "lookRecordToggle": "Запись взгляда",
        "recordLook": "Записать взгляд",
        "rerecordLook": "Перезаписать взгляд",
        "rewriteLookHint": "Нажмите пробел или кликните по сцене, и запись начнётся",
        "replaceLook": "Заменить записанный взгляд?",
        "stopLook": "Остановить взгляд",
        "pickObject": "Выбрать объект",
        "pickTarget": "выбрать цель",
        "pickTargetAction": "Выбрать цель",
        "pickPrompt": "Кликните объект… (Esc — отмена)",
        "targetLine": "Цель: {{name}} — сменить",
        "noLook": "нет записи",
        "lookRecordingLabel": "Запись взгляда",
        "figure": "Фигура",
        "needPath": "Сначала нарисуйте траекторию",
        "stopPlayback": "Остановите проезд",
        "smooth": "Плавно",
        "lookThrough": "Вид из камеры",
        "freeView": "Свободный просмотр",
        "clear": "Удалить траекторию",
        "clearCamera": "Удалить траекторию камеры",
        "clearCameraConfirm": "Удалить траекторию камеры?\nЭто нельзя отменить.",
        "clearObject": "Удалить траекторию объекта",
        "clearObjectConfirm": "Удалить траекторию объекта?\nЭто нельзя отменить.",
        "done": "Готово"
      },
      "play": "Воспроизвести (Пробел)",
      "stopPlay": "Стоп (Пробел)",
      "saveStart": "Сохранить как стартовую",
      "goToStart": "К стартовой",
      "captureViewpoint": "Снимок ракурса",
      "captureHintViewpoint": "Сделать фото ракурса",
      "captureHintFlight": "Записать пролёт",
      "viewpointName": "Ракурс",
      "viewpointSaved": "Ракурс сохранён",
      "overlay": {
        "recordStart": "Начать запись",
        "recordStop": "Остановить запись",
        "recordSave": "Сохранить запись",
        "keyW": "W — вперёд",
        "keyS": "S — назад",
        "keyA": "A — влево",
        "keyD": "D — вправо",
        "keyR": "R — вверх",
        "keyF": "F — вниз"
      },
      "saveScene": "Сохранить сцену",
      "sceneSaved": "Сцена сохранена",
      "closeUnsavedPrevizTitle": "Превиз не сохранён",
      "closeUnsavedPrevizMessage": "Есть записанный пролёт, который ещё не сохранён как превиз. Сохранить превиз?",
      "closeUnsavedPrevizSave": "Сохранить",
      "closeUnsavedPrevizDiscard": "Не сохранять",
      "undo": "Отменить",
      "redo": "Вернуть",
      "history": "История",
      "historyEmpty": "Пока нет действий",
      "historyClear": "Очистить",
      "historyActions": {
        "baseline": "Исходное состояние",
        "raiseSectors": "Поднять {{count}} сект.",
        "lowerSectors": "Опустить {{count}} сект.",
        "shiftFacesOut": "Сдвиг наружу · {{count}}",
        "shiftFacesIn": "Сдвиг внутрь · {{count}}",
        "light": "Свет",
        "platform": "Платформа",
        "objects": "Объекты",
        "faceGenerate": "Генерация стены",
        "faceUpload": "Загрузка стены",
        "faceLibrary": "Стена из библиотеки",
        "faceClear": "Очистка стены",
        "faceColor": "Цвет стены",
        "pathAddPoint": "Точка траектории",
        "pathDeletePoint": "Удаление точки",
        "pathClear": "Очистка траектории",
        "pathMovePoint": "Перемещение точки",
        "pathBend": "Изгиб",
        "pathLook": "Взгляд траектории",
        "pathSmooth": "Сглаживание",
        "pathDuration": "Длительность",
        "pathSpeed": "Скорость пролёта",
        "pathRecord": "Запись пролёта",
        "pathTrim": "Обрезка"
      },
      "startCameraSaved": "Стартовая позиция сохранена",
      "startCameraMissing": "Стартовая позиция ещё не сохранена",
      "liveSync": {
        "live": "Эфир",
        "following": "Следование"
      },
      "speed": "Скорость",
      "fov": "Обзор",
      "fovControl": {
        "label": "Угол обзора",
        "degrees_one": "{{count}} градус",
        "degrees_few": "{{count}} градуса",
        "degrees_many": "{{count}} градусов",
        "degrees_other": "{{count}} градуса",
        "focalMm": "{{mm}} мм"
      },
      "controlsHelp": "Подсказка по управлению",
      "createDialog": {
        "title": "Новая 3D-сцена",
        "create": "Создать сцену",
        "creating": "Создание…",
        "cancel": "Отмена",
        "location": "Локация",
        "noLocation": "Без локации",
        "platform": "Платформа",
        "walls": "Стены",
        "wallHeight": "Высота стен",
        "wallPreset": {
          "none": "Только платформа",
          "one": "Одна дальняя стена",
          "farTwo": "Две дальние стены",
          "three": "Три стены",
          "box": "Четыре стены"
        }
      },
      "environment": {
        "theme": "Время суток",
        "themeLight": "День",
        "themeDark": "Ночь",
        "themeToNight": "Переключить на ночь",
        "themeToDay": "Переключить на день",
        "themeSwitch": "Переключить время суток",
        "skyMarkup": "Разметка неба",
        "markupPlus": "Перекрестия",
        "markupDots": "Точки",
        "markupNone": "Нет"
      },
      "controlsHint": {
        "fly": "Пролёт:",
        "record": "Запись:",
        "light": "Свет:",
        "move": "движение туда, куда смотрите",
        "lmb": "ЛКМ",
        "orbit": "обзор",
        "faster": "поворот камеры",
        "upDown": "вверх / вниз",
        "playStop": "воспроизвести / остановить пролёт",
        "recordToggle": "начать / остановить запись",
        "trajectory": "Траектория:",
        "trajectoryToggle": "режим траектории",
        "captureViewpoint": "снимок ракурса",
        "lightDrag": "— высота и плоскость",
        "lightShiftDrag": "ближе / дальше к камере"
      },
      "toolbarMore": "Ещё",
      "controlsHintFly": "Пролёт: W A S D — движение туда, куда смотрите,\nR / F — вверх/вниз, ЛКМ + drag — обзор, ЛКМ + drag + Shift — поворот камеры.\nПробел — воспроизвести/остановить пролёт.\nShift+Пробел — начать/остановить запись.\nСвет: drag — высота и плоскость; Shift+тянуть — ближе/дальше к камере.",
      "deviceCamera": {
        "enable": "Телефон-камера",
        "disable": "Выключить телефон-камеру",
        "leftStick": "Стик стрейфа",
        "rightStick": "Стик полёта и поворота",
        "doubleTapExit": "Двойной тап — выход из телефон-камеры",
        "permissionDenied": "Нет доступа к ориентации устройства. Разрешите её в настройках браузера.",
        "unsupported": "Ориентация устройства на этом браузере недоступна.",
        "notReady": "Сцена ещё загружается. Коснитесь ещё раз чуть позже.",
        "tapToLook": "Коснитесь, чтобы включить обзор"
      },
      "mode": {
        "orbit": "Обзор",
        "fly": "Пролёт"
      },
      "timeline": {
        "scrub": "Таймлайн пролёта",
        "trim": "Обрезать пролёт до выбранного диапазона",
        "trimIn": "Начало диапазона",
        "trimOut": "Конец диапазона",
        "reset": "Очистить пролёт",
        "resetConfirm": "Очистить записанный пролёт?\nДействие необратимо.",
        "save": "Сохранить превиз",
        "saveToShot": "Использовать превиз",
        "saving": "Сохранение превиза…",
        "saved": "Превиз сохранён, видео готовится",
        "exportEmpty": "Не удалось записать видео — переснимите пролёт и сохраните снова.",
        "recTimer": "Запись: {{s}} с / {{max}} с",
        "speed": "Скорость камеры",
        "speedSplit": "Разделить",
        "speedPause": "Пауза",
        "takes": "Дубли пролёта",
        "takeName": "Дубль {{n}}",
        "newTake": "Новый дубль",
        "takesFull": "Все слоты дублей заняты. Удалите дубль, чтобы записать новый.",
        "renameTake": "Переименовать дубль",
        "renameTakeName": "Название",
        "deleteTake": "Удалить дубль",
        "deleteTakeConfirm": "Удалить дубль «{{name}}»?",
        "deleteTakeAction": "Удалить",
        "overwriteTake": "Перезаписать пролёт",
        "overwriteTakeConfirm": "В этом дубле уже есть пролёт.\nНовая запись его заменит.",
        "speedPresets": {
          "uniform": "Равномерно",
          "accel": "Разгон",
          "brake": "Торможение",
          "smooth": "Плавно",
          "pause": "Пауза"
        }
      },
      "viewPreset": {
        "top": "Вид сверху",
        "front": "Вид спереди",
        "back": "Вид сзади",
        "left": "Вид слева",
        "right": "Вид справа",
        "iso": "Изометрия"
      },
      "gizmo": {
        "move": "Переместить",
        "rotate": "Вращать",
        "scale": "Масштаб"
      },
      "groupObjects": "Сгруппировать",
      "ungroupObjects": "Разгруппировать",
      "lightIntensity": "Интенсивность света",
      "primitive": {
        "box": "Куб",
        "sphere": "Сфера",
        "cylinder": "Цилиндр",
        "cone": "Конус",
        "plane": "Плоскость"
      }
    },
    "scenePlatform": {
      "title": "{{name}} · секторная сцена",
      "description": "Платформа из секторов, рельеф и изображения на гранях.",
      "close": "Закрыть",
      "sectorsX": "Секторы по X",
      "sectorsZ": "Секторы по Z",
      "unit": "Единица измерения",
      "unitCm": "см",
      "unitM": "м",
      "apply": "Сохранить платформу",
      "modePlatform": "Платформа",
      "extrude": "Поднять",
      "intrude": "Опустить",
      "shiftOut": "Сдвиг наружу",
      "shiftIn": "Сдвиг внутрь",
      "faceTitle": "Грань",
      "faceEmpty": "На этой грани нет изображения.",
      "upload": "Загрузить",
      "library": "Библиотека",
      "libraryTarget": "Грань",
      "clear": "Очистить стену",
      "wallColor": "Цвет стены",
      "floorColor": "Цвет пола",
      "floorColorClear": "Сбросить цвет пола",
      "wallColorClear": "Сбросить цвет стены",
      "wallColorPresetGreen": "Зелёный #00B140",
      "prompt": "Промпт для этой стены",
      "generate": "Сгенерировать",
      "light": "Позиция освещения",
      "lightNorth": "Север",
      "lightEast": "Восток",
      "lightSouth": "Юг",
      "lightWest": "Запад",
      "lightTop": "Сверху",
      "errors": {
        "sectors_x": "Число секторов по X вне диапазона.",
        "sectors_z": "Число секторов по Z вне диапазона.",
        "unit": "Единица измерения — см или м.",
        "sector_size": "Размер сектора вне диапазона.",
        "platform_side": "Сторона платформы слишком большая.",
        "height": "Высота сектора вне диапазона."
      }
    },
    "angles": {
      "stripTitle": "Ракурсы",
      "allLink": "Все ракурсы",
      "pickerTitle": "Все ракурсы",
      "searchPlaceholder": "Поиск ракурса…",
      "noResults": "Ничего не найдено",
      "additionalItem": "Дополнительный ракурс",
      "additionalItemIndexed": "Ракурс {{index}}",
      "deleteViewpointConfirm": "Удалить ракурс «{{name}}»? Действие необратимо.",
      "sections": {
        "basic": "Базовые",
        "additional": "Дополнительные ракурсы"
      }
    },
    "dropDialog": {
      "title": "Куда поместить картинку",
      "description": "Скопировать «{{from}}» на «{{to}}» или поменять ракурсы местами.",
      "copy": "Скопировать",
      "swap": "Поменять местами",
      "cancel": "Отмена",
      "swapDisabled": "На целевом ракурсе нет картинки, чтобы поменять."
    },
    "edit": "Редактировать",
    "editNameHint": "Нажмите, чтобы переименовать",
    "delete": "Удалить",
    "regenerate": "Перегенерировать",
    "uploadVersion": "Загрузить файл",
    "reference": "Референс:",
    "model": "модель",
    "configureStudio": "Настроить в Studio",
    "lightboxTitle": "{{name}} · {{facing}}",
    "variantLightboxTitle": "{{name}} · «{{variant}}» · {{facing}}",
    "facing": {
      "north": "Север",
      "east": "Восток",
      "south": "Юг",
      "west": "Запад",
      "northShort": "С",
      "eastShort": "В",
      "southShort": "Ю",
      "westShort": "З",
      "three_quarterShort": "3/4",
      "topviewShort": "Сверху",
      "hasRef": "{{facing}} · есть референс",
      "noRef": "{{facing}} · нет референса",
      "hasRefAria": "{{facing}}, референс загружен",
      "noRefAria": "{{facing}}, референса нет"
    },
    "viewCaption": "Вид: {{view}}",
    "views": {
      "three_quarter": "3/4",
      "topview": "Вид сверху",
      "north": "Север",
      "east": "Восток",
      "south": "Юг",
      "west": "Запад",
      "panorama": "Панорама"
    },
    "generateView": "Сгенерировать {{view}}",
    "regenerateView": "Перегенерировать {{view}}",
    "viewEmpty": "{{view}} ещё не сгенерирован",
    "facingPrereq": {
      "needThreeQuarter": "Сначала сгенерируйте или загрузите 3/4",
      "needNorth": "Сначала сгенерируйте или загрузите Север",
      "needEastWest": "Сначала сгенерируйте или загрузите Запад и Восток",
      "needGroundLevel": "Сначала сгенерируйте или загрузите 3/4 или Север",
      "needPanoramaBase": "Сначала сгенерируйте или загрузите Север или 3/4"
    },
    "enlargeImage": "Увеличить изображение",
    "referenceAlt": "Референс: {{name}}",
    "noReferenceFacing": "Нет референса для этого вида · загрузить или сгенерировать",
    "fieldDescription": "Описание",
    "fieldMood": "Настроение",
    "fieldVisualTraits": "Визуальные детали",
    "noDescriptions": "Описания пока нет. Откройте «Редактировать», чтобы заполнить.",
    "profilePlaceholder": "Опишите локацию. Вставляйте характеристики через @…",
    "variants": "Варианты (время / погода)",
    "facingsTitle": "Ракурсы",
    "addVariant": "Добавить вариант",
    "noVariants": "Пока нет вариантов.",
    "defaultVariantBadge": "Базовый",
    "locationBase": "Локация",
    "defaultVariantNoGenerate": "Базовый вариант совпадает с референсом локации — генерируйте на карточке локации выше",
    "noRef": "нет референса",
    "variantQueuedHint": "Генерация уже в очереди — отслеживайте прогресс на панели «Задачи»",
    "variantNeedBaseHint": "Сначала сгенерируйте или загрузите базовый референс локации — он будет использован как основа для варианта",
    "variantGenerateHint": "Сгенерировать референс этого варианта на основе базового",
    "destroyBlocked": "Локация используется в сценах или шотах.",
    "deleteLocation": "Удалить локацию «{{name}}»?",
    "deleteLocationConfirmTitle": "Удалить локацию «{{name}}»?",
    "deleteLocationConfirmMessage": "Карточка локации, варианты и связанные версии референсов будут удалены. Действие необратимо.",
    "deleteLocationConfirmAction": "Удалить",
    "deleteVariant": "Удалить вариант «{{name}}»? Связи с шотами сбросятся на «базовый».",
    "deleteVariantConfirmTitle": "Удалить вариант «{{name}}»?",
    "deleteVariantConfirmMessage": "Связи с шотами сбросятся на базовый референс локации. Действие необратимо.",
    "deleteVariantConfirmAction": "Удалить",
    "newLocation": "Новая локация",
    "editLocation": "Редактирование «{{name}}»",
    "newVariant": "Новый вариант локации",
    "editVariant": "Редактирование варианта «{{name}}»",
    "variantAlt": "Вариант {{name}}",
    "enlargeVariant": "Открыть увеличенное изображение для выбранной стороны",
    "enlargeVariantAria": "Увеличить изображение варианта «{{name}}»",
    "generating": "генерация",
    "queuedShort": "В очереди…"
  },
  "projectExport": {
    "toolbarBtn": "Экспорт проекта",
    "dialogTitle": "Экспорт проекта",
    "hint": "Выберите формат и запустите сборку в фоне. Прогресс виден в очереди задач; готовые файлы появятся в списке ниже. Хранятся 3 дня, до 10 экспортов на проект (старые удаляются).",
    "formatLabel": "Формат",
    "formatZip": "Zip-архив с видео",
    "formatZipHint": "Все видео-версии шотов по папкам.",
    "formatDavinci": "DaVinci Resolve",
    "formatDavinciHint": "Бины media по шотам и FCPXML-таймлайны с активными шотами.",
    "formatBadgeZip": "Zip",
    "formatBadgeDavinci": "DaVinci",
    "start": "Запустить экспорт",
    "download": "Скачать",
    "inProgress": "Собирается…",
    "progress": "{{percent}}%",
    "failed": "Ошибка сборки",
    "expired": "Файл удалён — срок хранения истёк",
    "queuedToast": "Экспорт запущен — прогресс в очереди задач.",
    "enqueueFailed": "Не удалось запустить экспорт ({{status}}).",
    "fetchFailed": "Не удалось обновить экспорт ({{status}})."
  },
  "team": {
    "headTitle": "Команда",
    "add": "Добавить",
    "invite": "Пригласить",
    "searchPlaceholder": "Имя или email",
    "moreActions": "Действия с сотрудником",
    "invitationColumns": {
      "status": "Статус",
      "sent": "Отправлено"
    },
    "footer": {
      "reset": "Сбросить поиск"
    },
    "empty": {
      "searchTitle": "По запросу никого нет."
    },
    "deactivated": "деактивирован",
    "roleAria": "Роль в проекте: {{name}}",
    "remove": "Снять с проекта",
    "removeConfirmTitle": "Снять {{name}} с проекта?",
    "removeConfirmBody": "{{name}} потеряет доступ к проекту «{{project}}», но останется сотрудником компании и в других своих проектах.\n\nГенерации и правки останутся в проекте. Вернуть можно через «Добавить».",
    "removeConfirmBodyOwner": "У {{name}} снимется роль в проекте «{{project}}», доступ по роли владельца компании сохранится.\n\nГенерации и правки останутся в проекте. Вернуть роль можно через «Добавить».",
    "removeConfirmAction": "Снять с проекта",
    "invitationPending": "ожидает · до {{date}}",
    "invitationPendingNoDate": "ожидает",
    "invitationExpired": "просрочено {{date}}",
    "resend": "Отправить ещё раз",
    "revoke": "Отозвать",
    "revokeConfirmWhole_one": "Приглашение отзывается целиком — вместе с ещё {{count}} проектом.",
    "revokeConfirmWhole_few": "Приглашение отзывается целиком — вместе с ещё {{count}} проектами.",
    "revokeConfirmWhole_many": "Приглашение отзывается целиком — вместе с ещё {{count}} проектами.",
    "revokeConfirmWhole_other": "Приглашение отзывается целиком — вместе с ещё {{count}} проектами.",
    "emptyText": "В проекте только вы. Коллега войдёт в компанию как Сотрудник и сразу получит доступ к проекту «{{project}}».",
    "emptyInvite": "Пригласить коллегу",
    "addDialog": {
      "title": "Добавить в проект",
      "description": "Сотрудники компании «{{company}}», которых ещё нет в проекте «{{project}}».",
      "searchPlaceholder": "Имя или email",
      "quotedName": "«{{name}}»",
      "inProject": "в проекте {{name}}",
      "inProjects": "в проектах {{names}}",
      "andMore": "и ещё {{count}}",
      "noProjects": "без проектов",
      "nothingFound": "Никого не нашли",
      "alreadyInProject": "Уже в проекте: {{names}}.",
      "inviteLinkPrefix": "Нет нужного человека —",
      "inviteLink": "пригласите нового",
      "roleTitle": "Роль в проекте",
      "roleHint": "одна на всех выбранных",
      "selected": "Выбрано: {{count}}",
      "submit_one": "Добавить {{count}} сотрудника",
      "submit_few": "Добавить {{count}} сотрудников",
      "submit_many": "Добавить {{count}} сотрудников",
      "submit_other": "Добавить {{count}} сотрудников",
      "submitEmpty": "Добавить"
    },
    "groups": {
      "team": "Команда",
      "owners": "Владельцы компании",
      "invitations": "Приглашения",
      "inactive": "Неактивные"
    },
    "generations": {
      "title": "Генерации",
      "allForPerson": "Все генерации пользователя →",
      "empty": "В этом проекте {{name}} ещё ничего не генерировал(а).",
      "emptyProject": "Генераций пока нет. Лента заполнится, как только кто-нибудь запустит сториборд или видео.",
      "neverSeen": "Ни разу не заходил(а) в проект.",
      "retry": "Повторить",
      "emptyForRange": "За выбранный период генераций нет.",
      "resetRange": "Показать все"
    },
    "stats": {
      "inProject": "В проекте",
      "activity": "Активность",
      "since": "с {{date}}",
      "invitedBy": "пригласил(а) {{name}}",
      "neverSeen": "не заходил(а)",
      "spend30d": "расход за 30 дней",
      "shareOfProject": "{{percent}}% расхода проекта",
      "perGeneration": "на генерацию",
      "total": "всего",
      "countIn30d_one": "{{count}} за 30 дней",
      "countIn30d_few": "{{count}} за 30 дней",
      "countIn30d_many": "{{count}} за 30 дней",
      "countIn30d_other": "{{count}} за 30 дней",
      "generations30d": "генерации за 30 дней"
    },
    "memberCard": "Карточка сотрудника",
    "openInMembers": "Открыть страницу сотрудника →",
    "invitationNoRole": "Без роли в проекте",
    "invitationExpiredShort": "просрочено",
    "invitationUntil": "до {{date}}",
    "invitationLastSent": "Последняя отправка",
    "invitationProjects": "Другие проекты",
    "invitationOtherProjects_one": "+ ещё {{count}} проект",
    "invitationOtherProjects_few": "+ ещё {{count}} проекта",
    "invitationOtherProjects_many": "+ ещё {{count}} проектов",
    "invitationOtherProjects_other": "+ ещё {{count}} проектов",
    "invitationAfterAccept": "Генерации появятся, когда приглашение примут.",
    "archivedInvitationsHint": "Проект в архиве — приглашениями сейчас нельзя управлять.",
    "overview": {
      "pickTitle": "Выберите сотрудника",
      "pickHint": "В карточке сотрудника — его активность, генерации и расходы за 30 дней. Пока никто не выбран, ниже сводка по всей команде.",
      "teamHeatmap": "Активность команды за год"
    }
  },
  "settings": {
    "headTitle": "Настройки",
    "title": "Настройки проекта",
    "duplicateTitle": "Дублирование проекта",
    "duplicateHint": "Копирование запускается в фоне и переносит только существующие объекты и файлы без вызовов API генерации.",
    "duplicateBtn": "Дублировать проект",
    "duplicateQueuedToast": "Копирование запущено — прогресс в очереди задач.",
    "duplicateEnqueueFailed": "Не удалось запустить дублирование ({{status}}).",
    "archiveTitle": "Архивирование проекта",
    "archiveScreenTitle": "Убрать проект из списка",
    "archiveLead": "«{{name}}» исчезнет со страницы проектов. Сценарий, шоты, медиа и команда останутся на месте: архив только прячет проект из списка и ничего не удаляет. Вернуть его обратно из интерфейса нельзя.",
    "archivePointLink": "Открыть проект по-прежнему можно по прямой ссылке.",
    "archivePointInvites": "Приглашения в архивный проект не отправляются.",
    "archiveBtn": "Архивировать проект",
    "archiveConfirmTitle": "Архивировать проект?",
    "archiveConfirmMsg": "Проект исчезнет со страницы проектов. Данные останутся, открыть его можно будет по прямой ссылке. Вернуть в список из интерфейса нельзя.",
    "archiveConfirmAction": "Архивировать",
    "companyAccessTitle": "Доступ компаний",
    "companyAccessHint": "Расшарьте проект другим компаниям.",
    "notShared": "Проект пока не расшарен другим компаниям.",
    "companyFallback": "Компания #{{id}}",
    "accessContent": "Контент",
    "accessView": "Только просмотр",
    "accessSettings": "Настройки",
    "revoke": "Отозвать",
    "company": "Компания",
    "selectCompany": "Выберите компанию…",
    "shareCompanySearch": "Поиск компании…",
    "shareCompanyEmpty": "Ничего не найдено",
    "accessLevel": "Уровень доступа",
    "accessContentOption": "Контент (без настроек)",
    "accessContentHint": "Наполнять проект без доступа к настройкам",
    "accessViewOption": "Только просмотр",
    "accessViewHint": "Доступ на чтение",
    "accessSettingsOption": "Настройки и контент",
    "accessSettingsHint": "Сотрудники могут менять настройки и контент",
    "share": "Расшарить",
    "duplicateDialogTitle": "Дублировать проект",
    "duplicateDialogHint": "Выберите источник и состав копии. Ассеты копируются внутри ActiveStorage, внешние сервисы не вызываются.",
    "sourceProject": "Проект-источник",
    "copyName": "Название копии",
    "copyNamePlaceholder": "Новая копия",
    "copySuffix": "(копия)",
    "targetCompany": "Целевая компания",
    "startCopy": "Запустить копирование",
    "sectionsTitle": "Разделы",
    "sectionsHint": "Выберите блок — поля справа.",
    "navGroups": {
      "project": "Проект",
      "manage": "Управление"
    },
    "cards": {
      "identity": "Название и тип",
      "style": "Стиль",
      "frame": "Кадр",
      "structure": "Структура",
      "billing": "Биллинг"
    },
    "tabs": {
      "story": "Исходная история",
      "storyHint": "логлайн · сценарий",
      "general": "Основные настройки",
      "generalHint": "название · формат · стиль",
      "providers": "Модели API",
      "providersHint": "текст · картинки · видео · звук",
      "prompts": "Системные промпты",
      "promptsHint": "переопределения для проекта"
    },
    "storyHint": "Текст истории или логлайн проекта. Используется как основа для генерации структуры сезона, сценария и промптов.",
    "openInScript": "Открыть в «Сценарии»",
    "storyPlaceholder": "Идея сериала, тон, крючок для вертикального формата…",
    "saveStory": "Сохранить историю",
    "name": "Название",
    "taskPrefix": "Префикс",
    "taskPrefixHint": "Тикеры задач выглядят как {{example}}. 2–4 латинские буквы, уникален в компании.",
    "taskPrefixChangeTitle": "Сменить префикс задач?",
    "taskPrefixChangeMsg": "Все тикеры задач проекта сменятся с {{from}} на {{to}}. Старые ссылки на задачи перестанут работать.",
    "taskPrefixChangeAction": "Сменить префикс",
    "genre": "Жанр",
    "genrePlaceholder": "Выберите жанр…",
    "uncategorizedGroup": "Без раздела",
    "narrativeTone": "Нарративный тон",
    "tonePlaceholder": "Выберите нарративный тон…",
    "tone": "Тональность",
    "medium": "Медиум",
    "mediumPlaceholder": "Введите название стиля для этого проекта",
    "mediumModalHint": "Если медиума нет в каталоге, будет использовано своё название только для этого проекта",
    "mediumSelectButton": "Выбрать визуальный медиум",
    "mediumClearButton": "Без стиля",
    "mediumModalTitle": "Выберите визуальный медиум",
    "mediumNoImage": "Нет превью",
    "mediumModalClose": "Закрыть",
    "mediumPreviewSelect": "Выбрать",
    "mediumPreviewZoom": "Увеличить превью",
    "mediumSaveButton": "Сохранить",
    "mediumNoResults": "Ничего не найдено",
    "deprecatedGenre": "Текущее значение устарело: «{{value}}». Сохраните настройки, чтобы актуализировать жанр.",
    "deprecatedTone": "Текущее значение устарело: «{{value}}». Сохраните настройки, чтобы актуализировать нарративный тон.",
    "deprecatedMedium": "Текущее значение устарело: «{{value}}». Сохраните настройки, чтобы актуализировать визуальный медиум.",
    "frameFormat": "Формат кадра",
    "frameFormatHint": "Один формат на весь сериал: применяется ко всем API сториборда и видео, а также к превью. Смена формата влияет на новые генерации; уже созданные кадры остаются в исходной пропорции.",
    "videoOutputFps": "FPS итоговых файлов",
    "videoOutputFpsHint": "Частота кадров при нормализации видео после генерации или загрузки. Смена настройки влияет на новые файлы; уже сохранённые клипы сохраняют свой fps.",
    "videoOutputFpsHintInherit": "Сейчас используется значение Studio ({{fps}} fps). Применяется к нормализации после генерации или загрузки.",
    "videoOutputFpsDefaultFromStudio": "По умолчанию (Studio) — {{fps}} fps",
    "videoOutputFpsOption": "{{fps}} fps",
    "projectType": "Тип проекта",
    "projectTypeHint": "Тип задаётся при создании и больше не меняется.",
    "visualStyle": "Стиль картинок (референсы героев и визуал)",
    "visualStyleHint": "Единая техника рендеринга для всех генераций изображений в проекте.",
    "stylesEnabled": "Стили каталога",
    "stylesEnabledHint": "Жанр, тон и медиум подмешиваются во все генерации. Выключение не удаляет выбранные значения.",
    "seasons": "Сезоны",
    "episodes": "Серий",
    "secPerEpisode": "Сек/серия",
    "spendLimitLabel": "Лимит расходов проекта",
    "spendLimitTooltip": "Счёт — откуда списываются деньги. Лимит — сколько проект может потратить за месяц с любого счёта. Сработает то, что кончится раньше.",
    "spendLimitNoneHint": "Проект тратит, пока хватает денег на счёте, лимита компании и личных лимитов людей.",
    "spendLimitLine": "потрачено {{spent}} · осталось {{left}}",
    "spendLimitEditHint": "Меняется в отдельном окне и сохраняется сразу; видят и меняют владельцы компании.",
    "duplicateSections": {
      "structure": "Структура",
      "directories": "Справочники",
      "media": "Медиа",
      "description": "Описание и исходная история",
      "settings": "Настройки проекта",
      "settingsHint": "формат, модели, стиль, provider-поля",
      "projectAssignments": "Команда проекта",
      "projectAssignmentsHint": "назначения участников на проект",
      "seasonsEpisodes": "Сезоны и серии",
      "seasonsEpisodesHint": "обязательная база для сцен и шотов",
      "scenes": "Сцены",
      "shots": "Шоты",
      "shotPresets": "Пресеты шотов",
      "shotPresetsHint": "скрытые template и preview шоты; зависит от шотов",
      "characters": "Герои",
      "characterAssets": "Ассеты героев",
      "characterAssetsHint": "reference sheet, sheets, scale pose, media, версии",
      "characterVoices": "Голоса героев",
      "characterVoicesHint": "голоса, design requests, превью",
      "characterLinks": "Связи героев со сценами, сериями и шотами",
      "props": "Предметы",
      "propAssets": "Ассеты предметов",
      "propAssetsHint": "reference sheet, inputs, версии образов, фигура масштаба, листы размеров предметов",
      "locations": "Локации",
      "locationVariants": "Варианты локаций",
      "locationVariantsHint": "нужны для ссылок из шотов",
      "locationAssets": "Ассеты локаций",
      "locationAssetsHint": "reference sheet, inputs, версии ракурсов, сохранённые 3D-ракурсы (нужны для углов на шотах)",
      "previzes": "Превизы",
      "previzesHint": "Видеопролёты 3D-сцен",
      "scene3ds": "3D-сцены",
      "scene3dsHint": "Layout и ракурсы 3D-сцен (нужны для превизов; привязка к локациям — только если включены Локации)",
      "cameraPresets": "Проектные пресеты камеры",
      "coverImage": "Обложка проекта",
      "referenceLibrary": "Библиотека референсов холста",
      "sketchLibrary": "Библиотека эскизов",
      "libraryUploads": "Загрузки библиотеки",
      "shotStoryboard": "Кадры сториборда шотов",
      "shotShootingBoard": "Кадры раскадровки шотов",
      "shotVideo": "Видео шотов",
      "shotReferenceInputs": "Входные референсы шотов",
      "assemblyTimeline": "Монтажный timeline",
      "assemblyTimelineHint": "tracks и clips, зависит от шотов",
      "animatic": "Аниматик серии",
      "animaticHint": "по умолчанию выключено",
      "animaticSegments": "Сегменты аниматика",
      "animaticSegmentsHint": "по умолчанию выключено",
      "generationSkills": "Скиллы",
      "generationSkillsHint": "Библиотека скиллов проекта и привязки к ассистентам"
    }
  },
  "studio": {
    "headTitle": "{{name}} — студия",
    "episodeOptionLabel": "S{{season}}E{{episode}} — {{title}}",
    "errors": {
      "promptLoadFailed": "Не удалось загрузить промпты",
      "versionsLoadFailed": "Не удалось загрузить версии.",
      "networkUnavailable": "Сеть недоступна.",
      "activateVersionFailed": "Не удалось активировать версию.",
      "saveVersionMarkFailed": "Не удалось сохранить метку версии.",
      "saveFrameMarkFailed": "Не удалось сохранить метку кадра.",
      "extractClipTaskFailed": "Ошибка постановки задачи вырезки."
    },
    "toolbar": {
      "genre": "Жанр:",
      "tone": "Тон:",
      "style": "Стиль:",
      "styles": "Стили:",
      "stylesDisabled": "Без стилей",
      "format": "Формат:",
      "episode": "Серия",
      "jobs": "Задачи",
      "versions": "Версии"
    },
    "sidebar": {
      "versions": "Версии",
      "tasks": "Задачи",
      "assistant": "Ассистент",
      "back": "К списку",
      "shotHeading": "Шот {{number}}",
      "defaultTaskTitle": "Замечания к Шоту {{number}}",
      "insertTimecode": "Вставить текущую секунду шота",
      "loadFailed": "Не удалось загрузить задачи.",
      "createFailed": "Не удалось создать задачу.",
      "createTask": "Создать задачу"
    },
    "emptyEpisode": "В этой серии пока нет сцен и кадров.",
    "viewer": {
      "video": "Видео",
      "frame": "Кадр",
      "source": "Исходник",
      "sourceTitleHasSegment": "Фрагмент аниматика для этого шота",
      "sourceTitleNoSegment": "Нет сегмента аниматика",
      "extractProcessing": "Вырезка сегмента…",
      "extractFailed": "Вырезка не удалась",
      "retry": "Повторить",
      "refClipNotExtracted": "Референс-клип ещё не вырезан",
      "extractSegment": "Вырезать сегмент",
      "videoNotGenerated": "Видео ещё не сгенерировано",
      "frameNotGenerated": "Кадр ещё не сгенерирован",
      "storyboardVersions": "Версии сториборда",
      "videoVersions": "Версии видео",
      "timelineAndMarks": "Микромонтаж",
      "noSavedVersions": "Нет сохранённых версий",
      "versionPreview": "Превью версии"
    },
    "promptRail": {
      "videoPrompt": "Промпт видео",
      "framePrompt": "Промпт кадра",
      "loading": "Загрузка…",
      "request": "Запрос",
      "promptNotSet": "Промпт не задан",
      "image": "Изображение",
      "noReferenceData": "Нет данных о персонажах, локации и кадрах для справки."
    },
    "references": {
      "videoFrames": "Кадры видео",
      "firstFrame": "Первый кадр",
      "lastFrame": "Последний кадр",
      "first": "Первый",
      "last": "Последний",
      "framesNotExtracted": "Кадры не извлечены",
      "transitionFrames": "Кадры перехода",
      "left": "Слева",
      "right": "Справа"
    },
    "animaticSegment": {
      "downloadMp4": "Скачать MP4",
      "extractAndDownload": "Вырезать и скачать",
      "extractFailedRetry": "Вырезка не удалась — попробуйте снова.",
      "titlePrefix": "Сегмент аниматика"
    },
    "shotAlt": "Шот {{label}}",
    "shotFallback": "Шот",
    "shotTitle": "{{label}} — {{summary}}"
  },
  "animatics": {
    "headTitle": "{{name}} — аниматики",
    "episodeOptionLabel": "S{{season}}E{{episode}} — {{title}}",
    "errors": {
      "createEpisodeFirst": "Сначала создайте серию для загрузки аниматика.",
      "uploadFailed": "Ошибка загрузки.",
      "splitFailed": "Ошибка выделения.",
      "markersSplitTaskFailed": "Ошибка постановки задачи.",
      "deleteSegmentFailed": "Не удалось удалить сегмент.",
      "extractClipTaskFailed": "Ошибка постановки задачи вырезки.",
      "refClipPending": "Видеоклип ещё не нарезан — задача нарезки запущена. Повторите после её завершения.",
      "transcriptionStartFailed": "Ошибка запуска расшифровки.",
      "historyLoadFailed": "Не удалось загрузить историю",
      "createShotFailed": "Ошибка создания шота.",
      "saveSceneFailed": "Ошибка сохранения сцены.",
      "markerAddFailed": "Не удалось добавить метку.",
      "markerSaveFailed": "Не удалось сохранить метку.",
      "markerDeleteFailed": "Не удалось удалить метку.",
      "deleteSourceFailed": "Не удалось снять файл."
    },
    "confirmDeleteAnimatic": "Удалить аниматик этой серии? Ролики, загруженные прямо в шотах, останутся.",
    "confirmSplitAllMarkers": "Сохранить метки на сервере, разрезать сегменты по ним в фоне и затем удалить метки с сервера после нарезки?",
    "shortSegmentWarn": {
      "title": "Сегмент короче 2 секунд",
      "message": "Один из сегментов после разреза будет короче 2 с. Для Seedance и раскадровки из аниматика такой клип растянется до 2 с заморозкой последнего кадра. Продолжить?",
      "confirm": "Разрезать"
    },
    "createShotModal": {
      "title": "Создать шот из сегмента",
      "firstFrame": "Первый кадр",
      "poster": "Постер",
      "lastFrame": "Последний кадр",
      "first": "Первый",
      "posterLabel": "Постер",
      "last": "Последний",
      "segment": "Сегмент {{number}}",
      "scene": "Сцена",
      "selectScene": "Выберите сцену...",
      "sceneOption": "Сцена {{number}}",
      "insertAfterShot": "Вставить после шота",
      "atBeginning": "В начало",
      "shotOption": "Шот {{number}}",
      "shotTitle": "Заголовок шота",
      "fromAnimatic": "Из аниматика",
      "videoDuration": "Длительность видео",
      "next": "Далее",
      "location": "Локация",
      "noLocation": "Без локации",
      "noLocationsInProject": "В проекте пока нет локаций.",
      "characters": "Герои",
      "noCharactersInProject": "В проекте пока нет персонажей.",
      "storyboardPrompt": "Промпт для генерации кадра",
      "storyboardPromptPlaceholder": "Опишите кадр для генерации...",
      "defaultPromptHint": "Можно оставить пустым — будет использован промпт по умолчанию.",
      "videoPrompt": "Промпт для генерации видео",
      "videoPromptPlaceholder": "Опишите видео для генерации...",
      "create": "Создать",
      "scenePrompt": "Сцена {{number}}{{titleSuffix}}. Кадр из аниматика, сегмент {{segment}}.",
      "scenePromptUntitled": "Кадр из аниматика, сегмент {{segment}}."
    },
    "toolbar": {
      "format": "Формат:",
      "episode": "Серия",
      "noEpisodes": "Нет серий",
      "deleteAnimatic": "Удалить аниматик",
      "jobs": "Задачи",
      "versions": "Версии"
    },
    "upload": {
      "createEpisodeFirst": "Сначала создайте серию, чтобы загрузить аниматик",
      "uploading": "Загрузка...",
      "dropHint": "Перетащите MP4 аниматика сюда или выберите файл",
      "chooseFile": "Выбрать файл"
    },
    "processing": {
      "title": "Готовим аниматик",
      "extractingDuration": "Извлекаем длительность видео...",
      "failed": "Ошибка обработки аниматика",
      "deleteAndReupload": "Удалить и загрузить заново",
      "stepUpload": "Загрузка файла",
      "stepMetadata": "Метаданные видео",
      "stepFrames": "Кадры таймлайна",
      "stepWebPreview": "Web-превью для плеера",
      "webPreviewBadge": "Готовим web-превью…",
      "preparingFramesHint": "Готовим кадры сегмента…"
    },
    "segment": {
      "label": "Сегмент {{number}}",
      "splitTitle": "Поставить границу сегмента в текущей позиции (S)",
      "split": "Разделить",
      "markerTitle": "Метка в текущей позиции плеера (M)",
      "marker": "Метка",
      "draftMarkersTitle": "Черновых меток: {{count}}",
      "splitAllMarkers": "Разрезать по всем меткам",
      "titlePrefix": "Сегмент",
      "sceneHeading": "Сцена сегмента",
      "shotLinkHeading": "Привязка к шоту",
      "unlink": "Отвязать",
      "unlinkShot": "Отвязать шот",
      "selectShot": "Выберите шот...",
      "sceneGroup": "Сцена {{number}}{{titleSuffix}}",
      "artifactsHeading": "Артефакты сегмента",
      "artifactsHint": "Нарезка от начала сегмента в окне видео-референса текущей модели (обычно 15 с, у Seedance 2.5 — до 30 с). Один проход ffmpeg даёт сразу немой MP4, MP4 со звуком и MP3.",
      "extractArtifacts": "Вырезать артефакты",
      "silentMp4Label": "Немой MP4 (reference_video)",
      "downloadSilentMp4": "Скачать немой MP4",
      "audioMp4Label": "MP4 со звуком (для предпросмотра)",
      "downloadAudioMp4": "Скачать MP4 со звуком",
      "noAudioSourceHint": "Исходник без звуковой дорожки — пропущено.",
      "mp3Label": "MP3 (reference_audio)",
      "downloadMp3": "Скачать MP3",
      "fileInterval": "Интервал в файле: {{start}} — {{end}}",
      "shootingBoardHeading": "Раскадровка в шот (Seedance)",
      "shootingBoardHint": "Кадры из окна сегмента (как у MP4-референса, в пределах лимита текущей модели видео), равномерно по времени; в полосе — первый и последний кадр окна.",
      "panelCount": "Число панелей",
      "buildShootingBoardStrip": "Собрать полосу в раскадровку шота",
      "linkShotForStrip": "Привяжите шот к сегменту, чтобы собрать раскадровку-полосу.",
      "timelineTitle": "Сегмент {{number}}: {{start}} — {{end}}",
      "sceneShort": "С{{number}}",
      "selectOnTimeline": "Выберите сегмент на таймлайне"
    },
    "transcription": {
      "heading": "Расшифровка сегмента",
      "moreDetails": "Подробнее",
      "processing": "Расшифровка в процессе...",
      "pending": "Расшифровка в очереди...",
      "notStarted": "Расшифровка ещё не запускалась.",
      "regenerate": "Перегенерировать",
      "transcribe": "Расшифровать",
      "history": "История",
      "detailTitle": "Расшифровка сегмента",
      "environment": "Окружение",
      "locationMatch": "Локация: {{name}}",
      "lighting": "Свет: {{value}}",
      "characters": "Персонажи",
      "dialogue": "Диалоги",
      "props": "Реквизит",
      "timing": "Тайминг",
      "animationIntent": "Режиссёрский замысел",
      "firstFrameNotes": "Заметки для первого кадра",
      "videoNotes": "Заметки для видео",
      "uncertainty": "Неуверенность",
      "historyTitle": "История расшифровок сегмента",
      "noRecords": "Нет записей."
    },
    "actions": {
      "createShotFromSegment": "Создать шот из сегмента",
      "deleteSegment": "Удалить сегмент"
    },
    "deleteSegmentDialog": {
      "title": "Удалить сегмент",
      "description": "Выберите, с каким соседом объединить интервал времени после удаления сегмента {{number}}.",
      "mergeLeft": "Объединить с левым",
      "mergeRight": "Объединить с правым",
      "segmentRef": " (сегм. {{number}})"
    },
    "artifactRow": {
      "processing": "Нарезка…",
      "failed": "Ошибка",
      "skipped": "Пропущено",
      "failedGeneric": "Не удалось.",
      "awaitingExtract": "Ожидает нарезки"
    },
    "bulk": {
      "title": "Массовые операции",
      "button": "Массовые",
      "close": "Закрыть",
      "running": "Массовая обработка…",
      "confirmTitle": "Запустить массовую операцию?",
      "confirmPipelineIntro": "Будет выполнено:",
      "confirmExtract": "Вырезать артефакты: {{count}}",
      "confirmTranscribe": "Расшифровать: {{count}}",
      "confirmCreateShots": "Создать шоты: {{count}}",
      "confirmRun": "Запустить",
      "errors": {
        "startFailed": "Не удалось запустить массовую операцию.",
        "unknown": "Неизвестная ошибка",
        "referenceClips": "Не удалось вырезать референс-клип",
        "transcription": "Ошибка расшифровки",
        "noScene": "Нет активной сцены",
        "shotCreate": "Не удалось создать шот"
      },
      "result": {
        "title": "Результат",
        "success": "Все сегменты обработаны успешно",
        "summary": "Готово {{done}} из {{total}}, ошибок {{failed}}",
        "allFailed": "Не удалось обработать ни одного сегмента",
        "errorsHeading": "Ошибки по сегментам",
        "segmentError": "Сегмент {{number}}: {{message}}",
        "moreErrors": "и ещё {{count}}",
        "dismiss": "Скрыть",
        "statusFailed": "Операция завершилась с ошибкой",
        "statusPartial": "Операция завершена с ошибками"
      },
      "blockers": {
        "noVideo": "Загрузите видео аниматика",
        "noScene": "Создайте активную сцену в эпизоде",
        "noFfmpeg": "ffmpeg недоступен на сервере"
      },
      "stats": {
        "total": "Всего сегментов",
        "withShot": "С шотом",
        "withoutShot": "Без шота",
        "withoutArtifacts": "Без артефактов",
        "withoutTranscription": "Без расшифровки"
      },
      "operations": {
        "extract": "Вырезать артефакты",
        "transcribe": "Расшифровать",
        "createShots": "Создать шоты",
        "createShotsHint": "Включает вырезку и расшифровку при необходимости"
      }
    },
    "sources": {
      "reel": "Лента:",
      "addFile": "Добавить видеофайл в конец ленты",
      "removeLast": "Снять последний файл ленты",
      "preparing": "Готовится",
      "failed": "Ошибка",
      "more": "Ещё {{count}}"
    },
    "confirmDeleteSource": "Снять последний файл ленты вместе с его сегментами?"
  },
  "episodeTimeline": {
    "sceneLabel": "Сцена {{number}}: {{title}}. Подробнее — полное описание.",
    "sceneUntitled": "без названия",
    "locationTitle": "Локация: {{name}}",
    "scene": "Сцена",
    "untitled": "Без названия",
    "noSceneDescription": "Описание сцены не задано",
    "characters": "Герои",
    "noCharacters": "Нет героев",
    "moreCharacters": "Ещё герои ({{count}}): {{names}}",
    "locations": "Локации",
    "noLocations": "Нет локаций",
    "moreLocations": "Ещё локации ({{count}}): {{names}}",
    "shotsWithFrame": "Шоты с кадром",
    "shotsWithVideo": "Шоты с видео",
    "createShot": "Создать шот",
    "noShots": "В сцене пока нет шотов.",
    "emptySceneTitle": "В сцене пока нет шотов",
    "emptySceneHint": "Добавьте пустой шот или разложите сцену по сценарию.",
    "emptySceneHintLong": "Добавьте пустой шот или попросите ассистента разложить сцену на шоты по сценарию.",
    "addShot": "Добавить шот",
    "shotsFromScript": "По сценарию",
    "shotsFromScriptTitle": "Попросить ассистента разложить сцену на шоты по сценарию",
    "noScenes": "В этой серии пока нет сцен.",
    "addFirstScene": "Добавить первую сцену",
    "addScene": "Добавить сцену",
    "shotsCount": "{{count}} шот.",
    "sceneDuration": "{{duration}}",
    "deleteScene": "Удалить сцену",
    "deleteSceneBlocked": "Сначала удалите все шоты",
    "deleteSceneConfirmTitle": "Удалить сцену?",
    "deleteSceneConfirmMessage": "Сцена #{{number}} «{{title}}» будет удалена безвозвратно.",
    "editSceneDescription": "Редактировать описание",
    "sceneDescriptionPlaceholder": "Описание сцены…",
    "editNameHint": "Нажмите, чтобы переименовать",
    "renameScene": "Переименовать сцену"
  },
  "voicesSection": {
    "title": "Голоса",
    "design": "Создать",
    "designHint": "Создать голос по текстовому описанию",
    "remix": "Ремикс",
    "remixHint": "Вариации существующего голоса",
    "remixSource": "Исходный голос",
    "ivc": "Клонировать",
    "ivcHint": "Клонирование голоса из аудиофайлов (IVC)",
    "import": "Импорт",
    "importHint": "Привязать существующий голос провайдера по voice_id",
    "importVoiceIdPlaceholder": "voice_id провайдера",
    "importNamePlaceholder": "Название (необязательно — возьмём у провайдера)",
    "minimaxIvcFilesHint": "Загрузите чистый сэмпл голоса (mp3/m4a/wav, 10 сек–5 мин, до 20 МБ).",
    "minimaxNeedNoiseReduction": "Шумоподавление",
    "minimaxNeedVolumeNormalization": "Нормализация громкости",
    "minimaxLanguageBoost": "Язык",
    "minimaxPreviewTextPlaceholder": "Необязательная фраза для превью клона",
    "minimaxPromptTextPlaceholder": "Транскрипт prompt-аудио (необязательно)",
    "minimaxPromptAudio": "Prompt-аудио",
    "minimaxPromptAudioHint": "Короткий пример речи (до 8 сек). Помогает точнее передать манеру и интонацию при клонировании.",
    "ivcFilesHint": "Загрузите 1–10 чистых аудиозаписей голоса (mp3/wav, суммарно от 1 минуты).",
    "ivcDescriptionPlaceholder": "Необязательное описание голоса",
    "ivcRemoveBackgroundNoise": "Убрать фоновый шум",
    "ivcRemoveBackgroundNoiseHint": "Изоляция аудио ElevenLabs на сэмплах. Если шума нет, качество может ухудшиться.",
    "ivcLabelsTitle": "Метки (необязательно)",
    "ivcLabels": {
      "language": "Язык (напр. en)",
      "accent": "Акцент (напр. american)",
      "gender": "Пол (напр. female)",
      "age": "Возраст (напр. young)"
    },
    "uploadAudio": "Выбрать аудиофайлы",
    "uploadOrDrop": "Добавить или перетащить файл",
    "recordAudio": "Записать аудио",
    "recordOr": "или",
    "recordDurationHint": "{{min}}–{{max}} секунд",
    "recordCountdownHint": "Запись начнётся после обратного отсчёта 3 секунды — приготовьтесь.",
    "recordGo": "Старт!",
    "recordUpTo": "Запись до {{max}} секунд",
    "recordingTooShort": "Запись слишком короткая. Нужно минимум {{min}} секунд.",
    "micPermissionDenied": "Доступ к микрофону запрещён. Разрешите его в настройках браузера и попробуйте снова.",
    "stopRecording": "Остановить запись",
    "cancelRecording": "Отменить запись",
    "removeFile": "Удалить файл",
    "promptPlaceholder": "Опишите голос: пол, возраст, тембр, акцент, манера речи…",
    "promptPlaceholderRemix": "Опишите изменения: выше тон, теплее тембр, медленнее речь…",
    "promptMinLength": "Минимум {{min}} символов",
    "previewTextLabel": "Превью-фраза",
    "previewTextPlaceholder": "Один текст для всех кандидатов",
    "previewTextMinLength": "Минимум {{min}} символов",
    "defaultPreviewText": "Съешь ещё этих мягких французских булок, да выпей же чаю — пусть голос звучит ясно, спокойно и естественно.",
    "namePlaceholder": "Название голоса",
    "nameMissing": "Укажите название голоса перед выбором превью",
    "generatePreviews": "Сгенерировать",
    "clone": "Клонировать",
    "cancel": "Отмена",
    "jobFailed": "Не удалось сгенерировать голос",
    "previewsTitle": "Превью — выберите понравившийся",
    "pick": "Выбрать",
    "pickName": "Название нового голоса:",
    "loading": "Загрузка голосов…",
    "empty": "Голосов пока нет. Создайте голос через Создание, Ремикс, Клонирование, Импорт или выберите из библиотеки.",
    "active": "Основной",
    "makeActive": "Сделать основным",
    "doubleClickActivate": "Двойной клик — сделать основным",
    "copyVoiceId": "Скопировать voice id",
    "voiceIdCopied": "Voice id скопирован",
    "voiceIdCopyFailed": "Не удалось скопировать voice id",
    "renameEdit": "Переименовать голос",
    "renameSave": "Сохранить название",
    "renameCancel": "Отмена",
    "delete": "Удалить голос",
    "deleteConfirm": "Удалить голос «{{name}}»?",
    "showDesignParams": "Показать параметры",
    "designParamsTitle": "Параметры дизайна",
    "actionsMenu": "Действия с голосом",
    "downloadPreview": "Скачать аудиозапись",
    "regeneratePreview": "Изменить превью",
    "regeneratePreviewTitle": "Превью голоса",
    "regeneratePreviewSubmit": "Сгенерировать",
    "regeneratePreviewTextMissing": "Укажите текст для превью",
    "regeneratePreviewTextTooLong": "Превью-фраза — максимум {{max}} символов",
    "advancedTitle": "Дополнительные параметры",
    "advanced": {
      "loudness": "Громкость",
      "guidanceScale": "Сила следования промпту",
      "quality": "Качество",
      "seed": "Seed",
      "shouldEnhance": "Улучшить описание",
      "autoGenerateText": "Автогенерация превью-фразы",
      "promptStrength": "Сила промпта",
      "referenceAudio": "Референсное аудио",
      "chooseAudio": "Выбрать аудиофайл",
      "optional": "Необязательно"
    },
    "advancedHints": {
      "loudness": "Уровень громкости сгенерированного голоса. −1 — самый тихий, 1 — самый громкий, 0 примерно соответствует −24 LUFS.",
      "guidanceScale": "Насколько строго ИИ следует промпту. Меньшие значения дают больше свободы, большие — сильнее привязывают к описанию. Слишком высокие значения могут сделать голос искусственным. Для длинных детальных промптов рекомендуются меньшие значения.",
      "quality": "Более высокое качество даёт лучший голос, но меньше разнообразия. Допустимый диапазон: −1–1.",
      "seed": "Целое число, управляющее генерацией. Один и тот же seed с теми же входами даёт тот же голос. Допустимый диапазон: 0–2147483647.",
      "shouldEnhance": "Улучшать описание голоса с помощью ИИ: простые промпты автоматически расширяются до более детальных.",
      "autoGenerateText": "Автоматически сгенерировать текст, подходящий для описания голоса.",
      "promptStrength": "Баланс между промптом и референсным аудио. 0 — почти без влияния промпта, 1 — почти без влияния референса. Только для eleven_ttv_v3 и при наличии референса (design) или при remix существующего голоса.",
      "referenceAudio": "Референсное аудио для генерации голоса. Включает настройку силы промпта. Только для модели eleven_ttv_v3."
    },
    "method": {
      "design": "создание",
      "remix": "ремикс",
      "ivc": "клон",
      "import": "импорт",
      "library": "библиотека"
    },
    "library": "Из библиотеки",
    "libraryHint": "Выбрать готовый голос из библиотеки провайдера",
    "libraryPickHint": "Голос добавится сразу — без генерации и списания.",
    "libraryPickPlaceholder": "Выберите голос…",
    "libraryOf": "Библиотека {{provider}}",
    "libraryAdded": "Голос «{{name}}» добавлен из библиотеки.",
    "defaultVoice": "Голос по умолчанию",
    "defaultVoiceHint": "Пока у героя нет своих голосов, озвучка идёт этим голосом.",
    "remixElevenlabsOnly": "Ремикс доступен только для ElevenLabs",
    "minimaxCloneExpiryHint": "MiniMax удаляет неиспользуемые клоны голоса — периодически озвучивайте им реплики, чтобы голос не пропал."
  },
  "agent": {
    "title": "Ассистент проекта",
    "scene3dTitle": "Ассистент 3D-сцен",
    "platformTitle": "Ассистент платформы",
    "shotContext": "шот {{label}}",
    "shotContextStripAria": "Референсы выбранного шота",
    "generateFrameShort": "Кадр",
    "generateVideoShort": "Видео",
    "clearShotSelection": "К общему ассистенту",
    "selectedShotChip": "Шот {{label}}",
    "placeholder": "Спросите ассистента…",
    "attachImage": "Приложить изображение или видео",
    "attachFromComputer": "Загрузить",
    "attachFromLibrary": "Из библиотеки",
    "attach": "Прикрепить",
    "dropOverlay": "Отпустите, чтобы прикрепить",
    "imageRemove": "Убрать вложение",
    "imageTooLarge": "Изображение больше 20 МБ",
    "videoTooLarge": "Видео больше 100 МБ",
    "imageBadType": "Нужен JPEG, PNG, WebP, GIF, MP4, WebM или MOV",
    "imageLimit": "Можно приложить не больше 10 файлов",
    "videoLimit": "Можно приложить не больше 2 видео",
    "imageFailed": "Не удалось разобрать вложение. Повторите попытку позже.",
    "imageDraftQuota": "Не хватает места в браузере — изображение пропадёт после обновления страницы.",
    "imageOnlyQueued": "Изображение",
    "videoOnlyQueued": "Видео",
    "attachmentOnlyQueued": "Вложение",
    "videoPreview": "Видео",
    "readOnlyHint": "Только просмотр — чат можно читать, но отправлять сообщения нельзя.",
    "typing": "Агент печатает…",
    "thinking": "Размышляю…",
    "thinkingPhrases": [
      "Размышляю…",
      "Смотрю контекст проекта…",
      "Сверяюсь со сценарием…",
      "Подбираю решение…",
      "Проверяю соседние шоты…",
      "Собираю ответ…",
      "Ещё секунду…",
      "Уточняю детали…"
    ],
    "workingTool": "Агент вызывает инструмент…",
    "toolStatus": {
      "improve_prompt": "Обновляю промпт шота",
      "update_shot_duration": "Меняю длительность шота",
      "update_shot_characters": "Меняю состав героев",
      "update_shot_location": "Обновляю локацию шота",
      "create_next_shot": "Создаю следующий шот",
      "create_shots_batch": "Создаю шоты",
      "create_transition_shot": "Создаю шот-переход",
      "create_scene": "Создаю сцену",
      "handoff_to_assistant": "Открываю нужный раздел",
      "analyze_images": "Смотрю вложение",
      "attach_task_file": "Прикрепляю файл задачи референсом",
      "regenerate_keyframe": "Готовлю перегенерацию кадра",
      "regenerate_video": "Готовлю перегенерацию видео",
      "generate_project_cover": "Готовлю генерацию обложки проекта",
      "create_character": "Создаю героя",
      "update_character": "Обновляю героя",
      "create_location": "Создаю локацию",
      "update_location": "Обновляю локацию",
      "create_prop": "Создаю реквизит",
      "update_prop": "Обновляю реквизит",
      "get_scene3d": "Загружаю 3D-сцену",
      "create_scene3d": "Создаю 3D-сцену",
      "update_scene3d": "Обновляю 3D-сцену",
      "update_scene3d_state": "Обновляю layout 3D-сцены",
      "delete_scene3d": "Удаляю 3D-сцену",
      "place_scene3d_object": "Ставлю объект на 3D-сцену",
      "place_scene3d_group": "Собираю предмет из примитивов",
      "update_scene3d_object": "Двигаю объект на 3D-сцене",
      "remove_scene3d_object": "Убираю объект с 3D-сцены",
      "set_scene3d_face_color": "Крашу грань 3D-сцены",
      "clear_scene3d_face": "Снимаю цвет грани",
      "generate_scene3d_face": "Готовлю генерацию грани",
      "set_scene3d_camera_path": "Записываю пролёт камеры",
      "update_canvas_prompt": "Обновляю промпт холста",
      "update_generation_skill": "Обновляю скилл",
      "propose_episode_script": "Готовлю вариант сценария"
    },
    "expand": "Развернуть",
    "collapse": "Свернуть",
    "execute": "Выполнить",
    "cancel": "Отменить",
    "stop": "Остановить",
    "stopping": "Останавливаю…",
    "error": "Ошибка агента",
    "interrupted": "Прогон прервался. Текст ответа сохранён — можно продолжить.",
    "internalError": "Внутренняя ошибка агента. Можно продолжить.",
    "networkError": "Не удалось связаться с AI-провайдером. Проверьте сеть или VPN и попробуйте снова.",
    "networkRetryIn": "Повтор через {{seconds}} с",
    "busy": "Агент уже обрабатывает запрос",
    "rateLimited": "Сервис агента перегружен. Подождите немного и отправьте сообщение снова.",
    "queueConfirmTitle": "Отправить следующим?",
    "queueConfirmMessage": "Агент ещё отвечает. Отправить это следующим запросом, когда закончит?",
    "queueReplaceTitle": "Заменить отложенный запрос?",
    "queueReplaceMessage": "Уже есть следующий запрос. Заменить его этим текстом?",
    "queueConfirm": "Отправить следующим",
    "queueReplace": "Заменить",
    "queuedNext": "Следующим: {{text}}",
    "queuedClear": "Убрать из очереди",
    "retry": "Повторить",
    "silentRetryHint": "Повторить последний ход без нового сообщения",
    "editMessage": "Редактировать",
    "editingBanner": "Редактирование сообщения",
    "editConfirmTitle": "Переотправить сообщение?",
    "editConfirmMessage": "Последующие ответы агента будут удалены, и запрос уйдёт заново.",
    "editConfirm": "Переотправить",
    "editCancel": "Отменить правку",
    "charactersUpdated": "Состав героев обновлён",
    "locationUpdated": "Локация шота обновлена",
    "continue": "Продолжить",
    "continuePhrase": "Продолжи с того места, где остановился",
    "loadError": "Не удалось загрузить историю",
    "skillsPicker": "Подключить скилл",
    "skillsEmpty": "Нет скиллов для добавления",
    "skillsNothingFound": "Нет подходящих скиллов",
    "confirmError": "Не удалось выполнить действие",
    "quickImprove": "Улучшить промпт этого шота",
    "quickKeyframe": "Перегенерировать кадр",
    "quickVideo": "Перегенерировать видео",
    "quickNextShot": "Создать следующий шот",
    "quickNextShotByScript": "Создать следующий шот по сценарию",
    "quickCreateCharacter": "Создать персонажа",
    "quickUpdateCharacterProfile": "Обновить профиль персонажа",
    "quickExtractCharacters": "Извлечь персонажей из сценария: создай или обнови героев с полными профилями (роль, описание, характер, внешность, визуальные детали)",
    "quickExtractCharactersLabel": "Извлечь из сценария",
    "quickExtractCharactersFromScriptLabel": "Извлечь героев",
    "quickGenerateCharacterReference": "Сгенерировать референс",
    "quickGenerateCharacterSheet": "Лист героя",
    "quickGenerateCharacterEmotionSheet": "Лист эмоций",
    "quickGenerateCharacterPortrait": "Портрет",
    "quickGenerateCharacterScalePose": "Масштабная поза",
    "quickGenerateCharacterMedia": "Видео-медиа",
    "quickRegisterSeedanceAvatar": "Seedance",
    "quickCreateLocation": "Создать локацию",
    "quickCreateScene3d": "Создать 3D-сцену",
    "quickDescribeScene3d": "Что на этой сцене",
    "quickPlaceScene3dHero": "Поставить героя",
    "quickPaintScene3dFace": "Покрасить выделенную грань",
    "quickUpdateLocationProfile": "Обновить профиль локации",
    "quickExtractLocations": "Извлечь локации из сценария: создай или обнови места с полными профилями (описание, настроение, визуальные черты)",
    "quickExtractLocationsLabel": "Извлечь из сценария",
    "quickExtractLocationsFromScriptLabel": "Извлечь локации",
    "quickGenerateLocationReference": "Сгенерировать референс",
    "quickCreateProp": "Создать реквизит",
    "quickUpdatePropProfile": "Обновить профиль реквизита",
    "quickExtractProps": "Извлечь реквизит из сценария",
    "quickShotsFromScript": "Создай сцены и шоты по текущему тексту сценария",
    "quickSummarizeScript": "Кратко перескажи текущий сценарий",
    "quickGeneratePropReference": "Референс",
    "quickGeneratePropFrontView": "Вид спереди",
    "quickCanvasImprove": "Улучшить промпт",
    "quickCanvasVideo": "Переключить на видео",
    "quickCanvasGenerate": "Сгенерировать",
    "updatingPrompt": "Обновляю промпт…",
    "promptUpdated": "Промпт обновлён",
    "savedPrompt": {
      "image": "Кадр",
      "video": "Видео",
      "shootingBoard": "Раскадровка",
      "prompt": "Промпт",
      "copy": "Скопировать промпт",
      "copied": "Промпт скопирован",
      "copyFailed": "Не удалось скопировать"
    },
    "durationUpdated": "Длительность шота: {{sec}} с",
    "videoReferencesUpdated": "Референсы шота обновлены",
    "startingAction": "Запускаю…",
    "actionStarted": "Генерация запущена",
    "handoff": {
      "surface": {
        "characters": "Ассистент героев",
        "locations": "Ассистент локаций",
        "props": "Ассистент реквизита",
        "shot": "Ассистент шота",
        "script": "Ассистент сценария",
        "tasks": "Задачи"
      },
      "status": {
        "running": "в работе",
        "done": "готово",
        "failed": "не удалось"
      },
      "tooltip": "{{surface}} · {{status}}",
      "tooltipWithTask": "{{surface}} · {{status}}: {{task}}"
    },
    "untitledProject": "Без названия",
    "emptyTitle": "Чат проекта «{{project}}»",
    "emptyShot": "Шот {{label}}",
    "emptyHint": "Диалог пока не начался",
    "dock": {
      "profile": "Профиль",
      "prompt": "Промпт",
      "assistant": "Ассистент",
      "dirtyAria": "Есть непросмотренные изменения"
    },
    "quickUpdateSkillBody": "Упрости / перепиши текст скилла",
    "quickSimplifySkill": "Сделай текст скилла короче и яснее",
    "quickClarifySkill": "Уточни инструкции в тексте скилла",
    "quickExplainSkill": "Что делает этот скилл?",
    "quickFindSkillContradictions": "Нет ли противоречий в тексте?",
    "quickListProjects": "Какие проекты сейчас в работе?",
    "quickCompanyBalance": "Какой баланс у студии?",
    "quickExplainSections": "Расскажи, зачем нужны разделы внутри проекта",
    "quickCreateProject": "Создай новый проект: ",
    "quickCreateProjectLabel": "Создать проект",
    "emptyCompanyTitle": "Ассистент студии «{{company}}»",
    "emptyCompanyHint": "Спросите про проекты, команду, баланс или попросите создать проект",
    "quickScriptFromSynopsis": "Напиши сценарий этой серии по её синопсису и сохрани драфтом",
    "quickScriptFromSynopsisLabel": "Сценарий из синопсиса",
    "quickFitScriptDuration": "Подгони сценарий серии под её целевую длительность (1 страница ≈ 1 минута) и сохрани драфтом",
    "quickFitScriptDurationLabel": "Подогнать под хронометраж"
  },
  "scenes3dPage": {
    "headTitle": "3D Сцены",
    "title": "3D Сцены",
    "add": "Добавить 3D-Сцену",
    "defaultName": "Сцена",
    "unlocated": "Без локации",
    "locationSceneCount_one": "{{count}} сцена",
    "locationSceneCount_few": "{{count}} сцены",
    "locationSceneCount_many": "{{count}} сцен",
    "rename": "Переименовать 3D-сцену",
    "editTitle": "Редактировать 3D-сцену",
    "renameNameLabel": "Название",
    "delete": "Удалить 3D-сцену",
    "deleteConfirm": "Удалить",
    "deleteFailed": "Не удалось удалить 3D-сцену.",
    "deleteWarning": "Удалить 3D-сцену «{{name}}»?",
    "assignLocation": "Привязать локацию",
    "assignLocationTitle": "Привязать локацию",
    "assignLocationSave": "Сохранить",
    "assignLocationFailed": "Не удалось обновить локацию.",
    "unassignLocation": "Отвязать от локации",
    "unassignLocationTitle": "Отвязать от локации",
    "unassignLocationConfirm": "Отвязать",
    "unassignLocationWarning": "Отвязать сцену «{{name}}» от локации «{{location}}»?",
    "unassignLocationFailed": "Не удалось отвязать локацию.",
    "empty": {
      "title": "Пока нет 3D-сцен",
      "description": "Создайте сцену для раскладки локации, ракурсов и видеопролётов."
    },
    "viewpoints": {
      "title": "Ракурсы",
      "itemIndexed": "Ракурс {{index}}",
      "delete": "Удалить ракурс",
      "deleteConfirm": "Удалить ракурс «{{name}}»? Действие необратимо."
    },
    "media": {
      "tab": "Ракурсы",
      "previzes": "Превизы",
      "previzesEmpty": "Превизов пока нет",
      "viewpointsEmpty": "Ракурсов пока нет",
      "loading": "Загрузка…",
      "viewpointCount": "Ракурсы",
      "previzCount": "Превизы"
    },
    "objects": {
      "tab": "Объекты",
      "empty": "На сцене пока нет объектов",
      "showPath": "Показать траекторию"
    },
    "chats": {
      "shared": "Общий",
      "location": "Локация",
      "scene": "Сцена"
    }
  }
}
